jQuery(document).ready(function ($) {
    /* ----------------------------------------------------------------------
| shippingMessage
|------------------------------------------------------------------------
| Dynamically change shipping message depending on requirements.
*/

    const shippingMessage = (cart) => {
        if (!cart) {
            return;
        }

        /* Required Variables */
        const targets = document.querySelectorAll('[data-shipping-message]');
        const shippingMessageDefault =
            window.theme.strings.shippingMessageDefault;
        const shippingMessageMore = window.theme.strings.shippingMessageMore;
        const shippingMessageQualified =
            window.theme.strings.shippingMessageQualified;
        const shippingMessageThreshold =
            window.theme.strings.shippingMessageThreshold;
        const required = [
            shippingMessageDefault,
            shippingMessageMore,
            shippingMessageQualified,
            shippingMessageThreshold,
        ];

        /* Check Variables are present, abort if not */
        const hasValue = (value) => {
            return value;
        };

        if (!required.every(hasValue)) {
            console.log('Shipping Message: Required strings missing');
            return;
        }

        const difference = shippingMessageThreshold - cart.total_price / 100;

        /* Format Strings, once we know they exist */
        const shippingMessageDefaultFormatted = shippingMessageDefault.replace(
            '{{ value }}',
            `${shippingMessageThreshold}`
        );
        const shippingMessageMoreFormatted = shippingMessageMore.replace(
            '{{ value }}',
            `${difference}`
        );

        console.log(cart.total_price, shippingMessageThreshold);

        /* Reapply Correct messaging to any element with the data attribute */
        if (cart.total_price > 0.1) {
            if (cart.total_price >= shippingMessageThreshold * 100) {
                targets.forEach((element) => {
                    element.innerText = shippingMessageQualified;
                });
            } else {
                targets.forEach((element) => {
                    element.innerText = shippingMessageMoreFormatted;
                });
            }
        } else {
            targets.forEach((element) => {
                element.innerText = shippingMessageDefaultFormatted;
            });
        }
    };

    if ($('.clearfix.color input').length >= 2) {
        $('.clearfix.color').show();
    }

     $(document.body).on('click', '.product-form-collection-template .plp-swatch-element input, .template-search .plp-swatch-element input', function() {
    $(this).parents('.product-form-collection-template').find('.product-form__cart-submit span')
      .addClass('choose-size');
    $(this).parents('.new-grid__item-content').find('.text-choose')
      .hide();
  });


$(document.body).on('click', '.product-form__cart-submit span', function() {
    if ($(this).hasClass('choose-size')) {
      $(this).parents('.product-form-collection-template').find('.product-form__cart-submit').prop('disabled', false);
      $(this).parents('.new-grid__item-content').find('.text-choose')
        .hide();
    } else {
      $(this).parents('.new-grid__item-content').find('.text-choose')
        .show();
    }
  });


  $(document.body).on('click', '.product-single__meta .clearfix.size input', function() {
    $(this).parents('.product-single__meta').find('.product-form__cart-submit').prop('disabled', false);
    $(this).parents('.product-single__meta').find('.product-form__cart-submit span')
      .addClass('choose-size2');
    $(this).parents('.product-single__meta').find('.text-choose')
      .hide();
  });


  $(document.body).on('click', '.product-single__meta .product-form__cart-submit span', function() {
    	if ($(this).hasClass('choose-size2')) {
      $(this).parents('.product-single__meta').find('.product-form__cart-submit')
        .prop('disabled', false);
      $(this).parents('.product-single__meta').find('.text-choose')
        .hide();
    } else {
      $(this).parents('.product-single__meta').find('.text-choose')
        .show();
    }
  });

    $('.search-header__input').keyup(() => {
        $('.search-header__submit').prop('disabled', false);
    });

    // scroll
    $('.scroll-nav').on('click', 'a', function (event) {
        event.preventDefault();
        const id = $(this).attr('href');
        const top = $(id).offset().top;
        $('body,html').animate({ scrollTop: top }, 1000);
    });

    // acardeon
    $('.item-acardeon').on('click', function () {
        $(this).find('.item-acardeon-desc').slideToggle();
        $(this).find('.item-acardeon-header').toggleClass('active');
    });

    // animated
    if ($('.animated-row').length) {
        $('.animated-row').each(function () {
            const $this = $(this);
            $this.find('.animate').each(function (i) {
                const $item = $(this);
                const animation = $item.data('animate');
                $item.waypoint(
                    () => {
                        setTimeout(() => {
                            $item
                                .addClass(`animated ${animation}`)
                                .removeClass('animate');
                        }, i * 1000);
                    },

                    {
                        offset: '90%',
                        triggerOnce: true,
                    }
                );
            });
        });
    }

    // Slick Carousel
    const $slideshow = $('.template-index .slideshow');

    if ($slideshow.length) {
        $slideshow.on(
            'beforeChange',
            (event, slick, currentSlide, nextSlide) => {
                const $currentSlide = $(`[data-slick-index="${currentSlide}"]`);
                const $currentSlideVideo = $currentSlide.find('iframe');
                const $nextSlide = $(`[data-slick-index="${nextSlide}"]`);
                const $video = $nextSlide.find('iframe');

                if ($currentSlideVideo.length > 0) {
                    const updatedVideoSrc = $currentSlideVideo
                        .attr('src')
                        .replace('&background=1&autoplay=1', '');

                    $currentSlideVideo.attr('src', updatedVideoSrc);
                }

                if ($video.length > 0) {
                    const newVideoSrc = `${$video.attr(
                        'src'
                    )}&background=1&autoplay=1`;

                    $video.attr('src', newVideoSrc);
                }
            }
        );
    }

    // Images slideshow section
    const $imagesSlideshow = $('.images-slideshow__slides');

    if ($imagesSlideshow.length) {
        $imagesSlideshow.slick({
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
        });
    }

    // category slideshow section
    const $categorySlideshow = $('.category-slider');

    if ($categorySlideshow.length) {
        $categorySlideshow.slick({
            dots: false,
            arrows: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '70px',
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '70px',
                    },
                },
            ],
        });
    }

    // category slideshow section
    const $featuredSlideshow = $('.featured-slider');

    if ($featuredSlideshow.length) {
        $featuredSlideshow.slick({
            dots: true,
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 543,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }

    // services slideshow section
    // const $servicesSlideshow = $('.service-slider');

    // if ($servicesSlideshow.length) {
    //   $servicesSlideshow.slick({
    //     dots: true,
    //     arrows: false,
    //     slidesToShow: 4,
    //     slidesToScroll: 1,
    //     responsive: [
    //       {
    //         breakpoint: 1200,
    //         settings: {
    //           slidesToShow: 3,
    //           slidesToScroll: 1,

    //         },
    //       },
    //       {
    //         breakpoint: 750,
    //         settings: {
    //           slidesToShow: 2,
    //           slidesToScroll: 1,

    //         },
    //       },
    //       {
    //         breakpoint: 544,
    //         settings: {
    //           slidesToShow: 2,
    //           slidesToScroll: 1,

    //         },
    //       },
    //     ],
    //       });
    //       }

    // Browse categories slideshow section

    const $browseCategoriesSlideshow = $('.browse-categories__items');

    if ($browseCategoriesSlideshow.length) {
        const options = {
            dots: false,
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: false,
            centerPadding: '0px',
            responsive: [
                {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '70px',
                    },
                },
            ],
        };

        if ($browseCategoriesSlideshow.data('autoplay')) {
            options.autoplay = true;
            options.autoplaySpeed =
                $browseCategoriesSlideshow.data('autoplay') * 1000;
        }

        $browseCategoriesSlideshow.slick(options);
    }
    // Bestsellers slideshow section
    const $bestsellersSlideshow = $('.bestsellers__items');

    if (
        $bestsellersSlideshow.length &&
        !$bestsellersSlideshow.hasClass('new-arrivals') &&
        !$bestsellersSlideshow.hasClass('show-more-collection')
    ) {
        $bestsellersSlideshow.slick({
            dots: false,
            arrows: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            centerMode: false,
            infinite: false,
            responsive: [
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 3,
                        arrows: false,
                    },
                },
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 2,
                        arrows: false,
                    },
                },
                {
                    breakpoint: 1198,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 2,
                        arrows: false,
                    },
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        arrows: false,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: false,
                    },
                },
                {
                  breakpoint: 480,
                  settings: {
                      slidesToShow: 1.5,
                      slidesToScroll: 1,
                      arrows: false,
                  },
              },
            ],
        });
    }

    // Bestsellers slideshow section
    const $newArrivalsSlideshow = $('.new-arrivals');

    if ($newArrivalsSlideshow.length) {
        $newArrivalsSlideshow.slick({
            dots: false,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            centerMode: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: 'unslick',
                },
            ],
        });
    }

    // Show more slideshow section
    const $showMoreSlideshow = $('.show-more-collection');

    if ($showMoreSlideshow.length) {
        $showMoreSlideshow.slick({
            dots: false,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            centerMode: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        arrows: true,
                        prevArrow:
                            '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"><g><path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z" /></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>',
                        centerMode: false,
                    },
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        arrows: true,
                        prevArrow: '',
                        nextArrow:
                            '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"><g><path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z" /></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>',
                        centerMode: false,
                    },
                },
            ],
        });
    }

    // Newsletter section

    const $newsletterFormBtn = $('.newsletter__form--double button');

    $newsletterFormBtn.on('click', function () {
        const $newsletterForm = $(this).parent();
        const $newsletterFormTextInput =
            $newsletterForm.find('input[type="text"]');
        const $newsletterFormEmailInput = $newsletterForm.find(
            'input[type="email"]'
        );
        const $newsletterFormCheckbox = $newsletterForm.find(
            'input[type="checkbox"]'
        );
        const textInputValue = $newsletterFormTextInput.val();
        const checkboxValue = $newsletterFormCheckbox.is(':checked');

        if (textInputValue !== '' && checkboxValue === true) {
            $newsletterFormTextInput.fadeOut('300');
            window.setTimeout(() => {
                $newsletterFormEmailInput.fadeIn('300');
            }, 300);
        }
    });

    // Lookbook popup

    $('a[href="#open-popup-cookie"]').on('click', (e) => {
        e.preventDefault();
        $('.cookie-popup').fadeIn();
    });

    $('a[href="#open-popup-login"]').on('click', (e) => {
        e.preventDefault();
        $('.login-popup-1').fadeIn();
    });

    $('a[href="#open-popup-login2"]').on('click', (e) => {
        e.preventDefault();
        $('.login-popup-2').fadeIn();
    });

    $('.login-popup__close').on('click', () => {
        $('.login-popup-1').fadeOut();
        $('.login-popup-2').fadeOut();
    });
    $(document).on('click', '.login-popup .lookbook-popup__overlay', (e) => {
        $('.login-popup-1').fadeOut();
        $('.login-popup-2').fadeOut();
    });

    if ($('section').hasClass('lookbook')) {
        const $openPopupBtn = $('a[href="#open-popup"]');
        const $popup = $('.lookbook-popup__wrapper');
        const $popupContentWrapper = $('.lookbook-popup__content-wrapper');
        const $popupContainer = $('.lookbook-popup__container');
        const $closePopupBtn = $('.lookbook-popup__close');

        $popupContentWrapper.each(function () {
            $popupContainer.append($(this));
        });

        $popupContainer.slick({
            arrows: true,
            fade: true,
            slidesToShow: 1,
            slidesToScroll: 1,
        });

        window.setTimeout(() => {
            $popup.css('display', 'none').css('visibility', 'visible');
        }, 1500);

        $openPopupBtn.on('click', function (e) {
            e.preventDefault();

            const index = parseInt(
                $(this).parents('.lookbook__item-wrapper').data('index')
            );

            $popup.fadeIn();
            $popupContainer.slick('slickGoTo', index);
        });

        $(document).on('click', '.lookbook-popup__overlay', (e) => {
            if ($(e.target).closest($popupContainer).length === 0) {
                $popup.fadeOut();
            }
        });

        $closePopupBtn.on('click', () => {
            $popup.fadeOut();
        });
    }

    if ($('body').hasClass('template-page-about-us')) {
        const $collection = $('.shop-collection__items');
        const $collectionItem = $('.shop-collection__item');

        if ($collectionItem.length > 4) {
            $collection.slick({
                arrows: true,
                dots: true,
                slidesToShow: 4,
                slidesToScroll: 4,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                            centerMode: true,
                        },
                    },
                ],
            });
        }
    }

    // Footer mobile accordion

    const $accordionHeading = $('.footer__menu-title');
    const $accordionContent = $('.footer__menu');

    $accordionHeading.on('click', function () {
        if ($(window).width() <= 749) {
            $(this).toggleClass('open');
            $(this).parent().find($accordionContent).slideToggle(300);
        }
    });

    // Orders accordion

    const $orderToggle = $('.order-toggle');

    $orderToggle.on('click', function (e) {
        e.preventDefault();

        const $parentItem = $(this).parents('.account_order-item');

        $parentItem.toggleClass('active');
        $parentItem.find('.account__dashboard-order').slideToggle(300);
    });

    // Mobile navigation

    const $hamburger = $('.site-header__menu');
    const $mobileMenu = $('.mobile-navigation__wrapper');
    const $closeMobileMenu = $('.mobile-navigation__close');
    const $openMobileDropdown = $('.mobile-navigation__link.has-dropdown');
    const $mobileDropdown = $('.mobile-navigation__dropdown');
    const $mobileBack = $('.back-arrow');

    $hamburger.on('click', () => {
        $mobileMenu.fadeIn(300);
        $('body').addClass('fixed');
    });

    $closeMobileMenu.on('click', () => {
        $mobileMenu.fadeOut(300);
        $('body').removeClass('fixed');
        $("details").removeAttr("open");
    });
    $mobileBack.on('click', () => {
      $("details").removeAttr("open");
    });
    
    
    

    $openMobileDropdown.on('click', function () {
        $(this).toggleClass('open');
        $(this).parent().find($mobileDropdown).slideToggle(300);
    });

    const url = window.location.href;
    const $showOrdersBtn = $('a[href="/account#orders"]');
    const $showDashboardBtn = $('a[href="/account#dashboard"]');
    const $dashboard = $('#tab-dashboard');
    const $orders = $('#tab-orders');
    const $accountNavigation = $('#account-navigation');

    if (url.indexOf('#orders') !== -1) {
        $dashboard.hide();
        $orders.show();

        $('.account__navigation--desktop li').removeClass('active');
        $('.account__navigation--desktop li:nth-child(3)').addClass('active');
        $accountNavigation.val('/account#orders');
    }

    $showOrdersBtn.on('click', (e) => {
        $dashboard.fadeOut(300);
        $orders.fadeIn(300);

        $('.account__navigation--desktop li').removeClass('active');
        $('.account__navigation--desktop li:nth-child(3)').addClass('active');

        $('html, body').animate({ scrollTop: 0 }, 300);
    });

    $showDashboardBtn.on('click', (e) => {
        $orders.fadeOut(300);
        $dashboard.fadeIn(300);

        $('.account__navigation--desktop li').removeClass('active');
        $('.account__navigation--desktop li:nth-child(1)').addClass('active');
    });

    $(document).on('change', '#account-navigation', function () {
        const valueSelected = this.value;

        if (window.location.pathname === '/account') {
            if (valueSelected === '/account#orders') {
                $dashboard.fadeOut(300);
                $orders.fadeIn(300);
                window.history.pushState('', '', '/account#orders');
            } else if (valueSelected === '/account#dashboard') {
                $orders.fadeOut(300);
                $dashboard.fadeIn(300);
            } else {
                window.location.href = window.location.origin + valueSelected;
            }
        } else {
            window.location.href = window.location.origin + this.value;
        }
    });

    if (url.indexOf('swymWishlist') !== -1) {
        if (customer) {
            $('.main-content').prepend(
                '<div class="account__navigation account__navigation--mobile">\n' +
                    '\t<div class="account__navigation-selector">\n' +
                    '\t\t<label>Menu</label>\n' +
                    '\t\t<select id="account-navigation">\n' +
                    '\t\t\t<option value="/account#dashboard" data-option="#dashboard">Dashboard</option>\n' +
                    '\t\t\t<option value="/account/addresses">Account details</option>\n' +
                    '\t\t\t<option value="/account#orders" data-option="#orders">My orders</option>\n' +
                    '\t\t\t<option value="/pages/wishlist" selected="selected">Wish list</option>\n' +
                    '\t\t\t<option value="/account/logout">Logout</option>\n' +
                    '\t\t</select>\n' +
                    '\t</div>\n' +
                    '</div> \n' +
                    '<div class="account__navigation account__navigation--desktop">\n' +
                    '\t<ul>\n' +
                    '\t\t<li>\n' +
                    '\t\t\t<a href="/account#dashboard" data-tab="#dashboard">Dashboard</a>\n' +
                    '\t\t</li>\n' +
                    '\t\t<li>\n' +
                    '\t\t\t<a href="/account/addresses">Account details</a>\n' +
                    '\t\t</li>\n' +
                    '\t\t<li>\n' +
                    '\t\t\t<a class="active" href="/account#orders" data-tab="#orders">My orders</a>\n' +
                    '\t\t</li>\n' +
                    '\t\t<li class="active">\n' +
                    '\t\t\t<a href="/pages/wishlist">Wish list</a>\n' +
                    '\t\t</li>\n' +
                    '\t\t<li>\n' +
                    '\t\t\t<a href="/account/logout">Logout</a>\n' +
                    '\t\t</li>\n' +
                    '\t</ul>\n' +
                    '</div>'
            );
        }
    }

    // Cart page

    $(document).on('click', '.js-qty__adjust', function () {
        var id = $(this).data('id');
        var price = parseInt($(this).data('price'));
        var $quantityInput = $(this).parents('.ajax-cart__product-content').find('.js-qty__num');
        var quantity = parseInt($quantityInput.val());
        let newQuantity = quantity + 1;
        const $subtotalPricaLabel = $(this)
            .parents('.responsive-table-row')
            .find('.responsive-table__total');
        let subtotalPrice = ((newQuantity * price) / 100).toFixed(2);
        const $totalPricaLabel = $('.cart-footer__total-price');
        let totalPrice = parseInt($totalPricaLabel.attr('data-price'));

        if ($(this).hasClass('js-qty__adjust--plus')) {
            totalPrice = ((totalPrice + price) / 100).toFixed(2);
            //$.post('/cart/update.js', `updates[${id}]=${newQuantity}`);
          $.post('/cart/change.js', { quantity: newQuantity, id: id });
          //alert(newQuantity);
        /*  setTimeout(function(){
      $quantityInput.val(newQuantity);
            $subtotalPricaLabel.text(`£${subtotalPrice}`);
            $totalPricaLabel
                .attr('data-price', totalPrice * 100)
                .text(`£${totalPrice}`);
          },500);*/
           setTimeout(function(){
          updateCart();
            },300);
        } else if (quantity > 1) {
            newQuantity = quantity - 1;
            subtotalPrice = ((newQuantity * price) / 100).toFixed(2);
            totalPrice = ((totalPrice - price) / 100).toFixed(2);
            //$.post('/cart/update.js', `updates[${id}]=${newQuantity}`);
          $.post('/cart/change.js', { quantity: newQuantity, id: id });
         /* setTimeout(function(){
      $quantityInput.val(newQuantity);
            $subtotalPricaLabel.text(`£${subtotalPrice}`);
            $totalPricaLabel
                .attr('data-price', totalPrice * 100)
                .text(`£${totalPrice}`);
          },500);*/
          setTimeout(function(){
          updateCart();
            },300);
        }
    });

    $(document).on('click', '.ajax-cart__item--remove', function (e) {
        e.preventDefault();

        $.post(
            '/cart/update.js',
            `updates[${$(this).attr('data-id')}]=0`
        ).always(() => {
            updateCart();
        });
    });

    // Article template

    if ($('body').hasClass('template-article')) {
        const $articleImage = $('.article__content img');

        $articleImage.each(function () {
            const alt = $(this).attr('alt');

            if (alt !== '') {
                $(this).addClass('with-alt-text');
                $(this).parent().append(`<span>${alt}</span>`);
            }
        });
    }

    // Product template

    if ($('body').hasClass('template-product')) {
        const $tabHeading = $('.product-tabs__heading');
        const $tabText = $('.product-tabs__text');

        $tabHeading.on('click', function () {
            const index = $(this).data('index');
            const $text = $(`.product-tabs__text[data-index="${index}"]`);

            if ($text.length !== 0 && !$(this).hasClass('active')) {
                $tabHeading.removeClass('active');
                $(this).addClass('active');
                $tabText.not($text).hide();
                $text.fadeIn(500);
            }
        });

        // Swatches change

        $('.swatch :radio').change(function () {
            const optionIndex = $(this)
                .closest('.swatch')
                .attr('data-option-index');
            const optionValue = $(this).val();

            var variant_qty = $(this).next('.custom-swatch').attr('data-qty');

            if (variant_qty < 5) {
                $('.current-qty').text('Only ' + variant_qty + ' in stock');
            } else {
                $('.current-qty').text('');
            }

            $('.single-option-selector')
                .eq(optionIndex)
                .val(optionValue)
                .trigger('change');
        });

        // Size guide popup
        const triggers = document.querySelectorAll('[data-size-guide-trigger]');
        const popup = document.querySelector('[data-size-guide-popup]');

        if (triggers) {
            triggers.forEach((element) => {
                element.addEventListener('click', () => {
                    popup.classList.toggle('size-guide--active');
                });
            });
        }

        // Sticky product sidebar

        const $productSidebar = $('.product-single__meta');
        const $bottomFlag = $('.sticky-sidebar-bottom-flag');
        const sidebarHeight = $productSidebar.height();
        const startStickySidebar = $productSidebar.offset().top;
        const stopStickySidebar = $bottomFlag.offset().top;

        $(window).on('scroll', function () {
            const windowWidth = $(window).width();
            const scrollTop = $(this).scrollTop();
            const stopSidebar = scrollTop + sidebarHeight + 50;

            if (windowWidth >= 750) {
                if (scrollTop >= startStickySidebar) {
                    if (stopSidebar >= stopStickySidebar) {
                        $productSidebar.removeClass('sticky').addClass('fixed');
                    } else {
                        $productSidebar.removeClass('fixed').addClass('sticky');
                    }
                } else {
                    $productSidebar.removeClass('sticky');
                }
            }
        });
    }

    // Ajax add to cart

    const $cart = $('.ajax-cart');
    const $openCartIcon = $('.site-header__cart');
    const $closeCartIcon = $('.ajax-cart__close img');
    const $cartOverlay = $('.ajax-cart__overlay');

    $openCartIcon.on('click', (e) => {
        e.preventDefault();

        $('body').addClass('fixed');
        $cart.fadeIn();
    });

    $closeCartIcon.on('click', () => {
        $cart.fadeOut();
        $('body').removeClass('fixed');
    });

    $cartOverlay.on('click', (e) => {
        if ($(e.target).closest('.ajax-cart__container').length === 0) {
            $cart.fadeOut();
            $('body').removeClass('fixed');
        }
    });

    function updateCart() {
        const cart = $('.ajax-cart');
        const cartCount = $('.site-header__cart span');
        const cartContent = $('.ajax-cart__content');
        const emptyCartMessage =
            '<p class="ajax-cart__empty">Your cart is empty</p>';

        $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success(data) {
                console.log(data);

                const items = data.items;

                if (data.item_count !== 0) {
                    cartCount.text(data.item_count);
                    cartCount.removeClass('empty-cart');
                } else {
                    cartCount.text('');
                    cartCount.addClass('empty-cart');
                }

                if (items.length > 0) {
                    const cartItems = $('<div class="ajax-cart__products">');

                    Object.keys(items).forEach((key) => {
                        const item = items[key];
                        const cartItem = $('<div class="ajax-cart__product">');
                        const cartdiv = $('<div class="flex-div">');
                        const cartItemInfo = $(
                            '<div class="ajax-cart__product-content">'
                        );
                        const cartItemPrice = $(
                            `<span class="money"><span class="money">£${(
                                (item.price * item.quantity) /
                                100
                            ).toFixed(2)}</span>`
                        );
                        const cartItemTitle = $(
                            `<a href="${item.url}" class="ajax-cart__product-title">${item.product_title}</a>`
                        );
                        const cartItemImage = $(
                            `<a href="${item.url}" class="ajax-cart__image"><img src="${item.image}"></a>`
                        );
                        const CartRemove = $(
                            `<a href="#" class="ajax-cart__product-param ajax-cart__item--remove" data-id="${item.id}">Remove</a>`
                        );
                        const cartItemQuanity = $(`<div style="display: flex; justify-content: space-between; align-items: center;"><span class="ajax-cart__product-param quantity-param"><div class="js-qty"> <button type="button" class="js-qty__adjust js-qty__adjust--minus icon-fallback-text ajax-btn" data-price="${item.price}" data-id="${item.id}"> <span class="icon icon-minus" aria-hidden="true"></span> <span class="fallback-text" aria-hidden="true">-</span> </button> <input type="text" class="js-qty__num" value="${item.quantity}" min="1" aria-label="quantity" pattern="[0-9]*" name="updates[]"> <button type="button" class="js-qty__adjust js-qty__adjust--plus icon-fallback-text ajax-btn" data-price="${item.price}" data-id="${item.id}"> <span class="icon icon-plus" aria-hidden="true"></span> <span class="fallback-text" aria-hidden="true">+</span> </button> </div></span><span class="money"><span class="money">£${(
                            (item.price * item.quantity) /
                            100
                        ).toFixed(2)}</span></div>`);
                        const variantOptions = item.variant_options;
                        let cartItemVariantTitle = '';

                        if (variantOptions[0] !== 'Default Title') {
                            cartItemVariantTitle = $(
                                `<span class="ajax-cart__product-param">Size: ${variantOptions[0]}</span>`
                            );
                        }

                        if (variantOptions.length === 2) {
                            cartItemVariantTitle = $(
                                `<span class="ajax-cart__product-param">${variantOptions[0]}</span><span class="ajax-cart__product-param">${variantOptions[1]}</span>`
                            );
                        }

                        cartItemInfo.append(
                            cartItemTitle,
                            cartItemVariantTitle,
                            cartItemQuanity,
                            CartRemove
                        );
                        cartdiv.append(cartItemImage, cartItemInfo);
                        cartItem.append(cartdiv);
                        cartItems.append(cartItem);
                    });

                    cartContent.html('').append(cartItems);
                    $('.ajax-cart__link').removeClass('hide');
                } else {
                    cartContent.html('').append(emptyCartMessage);
                    $('.ajax-cart__link').addClass('hide');
                }

                $('.cart-footer__total-price').html(
                    '<span class="money">£' +
                        (data.total_price / 100).toFixed(2) +
                        '</span>'
                );

                cart.fadeIn();
                shippingMessage(data);
              $(".ajax-cart__youmaylike").load(location.href + " .ajax-cart__youmaylike");
              $(".shipping-savings-message").load(location.href + " .shipping-savings-message");
              $(".progress-bar").load(location.href + " .progress-bar");
              $(".progress").load(location.href + " .progress");
            },
        });
    }

$(document).on('click', '.size-item', function (e) {
$('.size-item').removeClass('active');
$(this).addClass('active');
});
  
$(document).on('click', '.size_add_to_cart', function (e) {
var variant_id = $(this).parent('.size_block').find('.size-item.active').attr('data-id');
var data = {
"id": variant_id,
"quantity": 1
}
$.ajax({
type: 'POST',
url: '/cart/add.js',
data: data,
dataType: 'json',
success: function() { 
const cart = $('.ajax-cart');
        const cartCount = $('.site-header__cart span');
        const cartContent = $('.ajax-cart__content');
        const emptyCartMessage =
            '<p class="ajax-cart__empty">Your cart is empty</p>';

        $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success(data) {
                console.log(data);

                const items = data.items;

                if (data.item_count !== 0) {
                    cartCount.text(data.item_count);
                    cartCount.removeClass('empty-cart');
                } else {
                    cartCount.text('');
                    cartCount.addClass('empty-cart');
                }

                if (items.length > 0) {
                    const cartItems = $('<div class="ajax-cart__products">');

                    Object.keys(items).forEach((key) => {
                        const item = items[key];
                        const cartItem = $('<div class="ajax-cart__product">');
                        const cartdiv = $('<div class="flex-div">');
                        const cartItemInfo = $(
                            '<div class="ajax-cart__product-content">'
                        );
                        const cartItemPrice = $(
                            `<span class="money">£${(
                                (item.price * item.quantity) /
                                100
                            ).toFixed(2)}</span>`
                        );
                        const cartItemTitle = $(
                            `<a href="${item.url}" class="ajax-cart__product-title">${item.product_title}</a>`
                        );
                        const cartItemImage = $(
                            `<a href="${item.url}" class="ajax-cart__image"><img src="${item.image}"></a>`
                        );
                        const CartRemove = $(
                            `<a href="#" class="ajax-cart__product-param ajax-cart__item--remove" data-id="${item.id}">Remove</a>`
                        );
                        const cartItemQuanity = $(`<div style="display: flex; justify-content: space-between; align-items: center;"><span class="ajax-cart__product-param quantity-param"><div class="js-qty"> <button type="button" class="js-qty__adjust js-qty__adjust--minus icon-fallback-text ajax-btn" data-price="${item.price}" data-id="${item.id}"> <span class="icon icon-minus" aria-hidden="true"></span> <span class="fallback-text" aria-hidden="true">-</span> </button> <input type="text" class="js-qty__num" value="${item.quantity}" min="1" aria-label="quantity" pattern="[0-9]*" name="updates[]"> <button type="button" class="js-qty__adjust js-qty__adjust--plus icon-fallback-text ajax-btn" data-price="${item.price}" data-id="${item.id}"> <span class="icon icon-plus" aria-hidden="true"></span> <span class="fallback-text" aria-hidden="true">+</span> </button> </div></span><span class="money"><span class="money">£${(
                            (item.price * item.quantity) /
                            100
                        ).toFixed(2)}</span></div>`);
                        const variantOptions = item.variant_options;
                        let cartItemVariantTitle = '';

                        if (variantOptions[0] !== 'Default Title') {
                            cartItemVariantTitle = $(
                                `<span class="ajax-cart__product-param">Size: ${variantOptions[0]}</span>`
                            );
                        }

                        if (variantOptions.length === 2) {
                            cartItemVariantTitle = $(
                                `<span class="ajax-cart__product-param">${variantOptions[0]}</span><span class="ajax-cart__product-param">${variantOptions[1]}</span>`
                            );
                        }

                        cartItemInfo.append(
                            cartItemTitle,
                            cartItemVariantTitle,
                            cartItemPrice,
                          cartItemQuanity,
                            CartRemove
                        );
                        cartdiv.append(cartItemImage, cartItemInfo);
                        cartItem.append(cartdiv);
                        cartItems.append(cartItem);
                    });

                    cartContent.html('').append(cartItems);
                    $('.ajax-cart__link').removeClass('hide');
                } else {
                    cartContent.html('').append(emptyCartMessage);
                    $('.ajax-cart__link').addClass('hide');
                }

                $('.cart-footer__total-price').html(
                    '<span class="money">£' +
                        (data.total_price / 100).toFixed(2) +
                        '</span>'
                );

                cart.fadeIn();
                shippingMessage(data);
              $(".ajax-cart__youmaylike").load(location.href + " .ajax-cart__youmaylike");
              $(".shipping-savings-message").load(location.href + " .shipping-savings-message");
              $(".progress-bar").load(location.href + " .progress-bar");
              $(".progress").load(location.href + " .progress");
            },
        });
  
},
error: function (data) {
alert(data.responseJSON.description);
}
});

});
  
    const productForm = '.product-form';

    $(document).on('submit', productForm, function (e) {
        e.preventDefault();

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: $(this).serialize(),
            success(data) {
                updateCart();
            },
        });
    });

    const $videoPlayIcon = $('.video-play-icon');
    const $videoCloseBtn = $('.vbox-close');

    $videoPlayIcon.on('click', function () {
        const $parent = $(this).parent();
        const $video = $parent.find('iframe');
        const videoSrc = $video.attr('src');

        $parent.find('.vbox-overlay').fadeIn();
        $video.attr('src', `${videoSrc}&autoplay=1`);
    });

    $videoCloseBtn.on('click', function () {
        const $parent = $(this).parent();
        const $video = $parent.find('iframe');
        const videoSrc = $video.attr('src');

        $parent.fadeOut();
        $video.attr('src', videoSrc.replace('&autoplay=1', ''));
    });

    const cookieBarVisibility = localStorage.getItem('cookie-bar');
    const $cookieBarClose = $('.cookie-bar__close');
    const $cookieBar = $('.cookie-bar');

    if (cookieBarVisibility !== 'closed') {
        $cookieBar.slideToggle();
    }

    $cookieBarClose.on('click', () => {
        $cookieBar.slideToggle();

        localStorage.setItem('cookie-bar', 'closed');
    });

    const $lightbox = $('.lightbox');
    const $lightboxSlideshow = $('.lightbox__content');
    const $lightboxImages = $lightboxSlideshow.find(
        '.product-single__photo-wrapper'
    );
    const $lightboxThumbnail = $('.lightbox__thumbnail');
    const $lightboxClose = $('.lightbox__close');

    if ($lightboxImages.length > 1) {
        $lightboxSlideshow.slick({
            dots: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow:
                '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"><g><path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z" /></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>',
            nextArrow:
                '<button class="slick-next slick-arrow" aria-label="Previous" type="button"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"><g><path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z" /></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>',
            fade: true,
            cssEase: 'linear',
        });
    }

    const $zoomImage = $('.product-single__photo-wrapper');

    $zoomImage.on('click', function () {
	    $lightbox.addClass('show_lightbox');
        const wW = $(window).width();
        const $childPhoto = $(this).find('.product-single__photo');

        if (
            !$(this).hasClass('has-hover-image') &&
            !$childPhoto.hasClass('has-video') &&
            wW > 767
        ) {
            const index = $(this).index();

            $lightbox.fadeIn(300);
            $lightboxSlideshow.slick('slickGoTo', index);
            $lightboxThumbnail.removeClass('active');
            $lightboxThumbnail.eq(index).addClass('active');
        }
        $lightboxSlideshow.slick('refresh');
    });

    $lightboxClose.on('click', () => {
        $lightbox.removeClass('show_lightbox');
        $lightbox.fadeOut(300);
    });

    $lightboxThumbnail.on('click', function () {
        const index = $(this).index();

        $lightboxThumbnail.removeClass('active');
        $(this).addClass('active');
        $lightboxSlideshow.slick('slickGoTo', index);
    });

    $lightboxSlideshow.on(
        'beforeChange',
        (event, slick, currentSlide, nextSlide) => {
            $lightboxThumbnail.removeClass('active');
            $lightboxThumbnail.eq(nextSlide).addClass('active');
        }
    );

    const $subject = $('.select-dropdown__placeholder');
    const $subjectItem = $('.select-dropdown__content li');
    const $subjectDropdown = $('.select-dropdown__content');
    const $subjectInput = $('.ContactFormSubject');
    const $subjectIcon = $('.subject-dropdown svg');

    $subject.on('click', function (e) {
        e.preventDefault();
        $(this).parent().find($subjectDropdown).slideToggle();
        $(this).parent().find($subjectIcon).toggleClass('rotate');
    });

    $subjectItem.on('click', function () {
        const itemValue = $(this).html();

        $(this).parent().find($subjectItem).removeClass('selected');
        $(this).addClass('selected');
        $(this).parents('.subject-dropdown').find($subject).html(itemValue);
        $(this)
            .parents('.subject-dropdown')
            .find($subjectDropdown)
            .slideToggle();
        $(this).parents('.subject-dropdown').find($subjectInput).val(itemValue);
        $(this)
            .parents('.subject-dropdown')
            .find($subjectIcon)
            .removeClass('rotate');
    });

    const $sidebarLink = $('.privacy-sidebar__linklist-item a');
    const $privacyTitles = $('.privacy__main h2');

    $privacyTitles.each(function () {
        $(this).attr('data-id', $(this).html().toLowerCase());
    });

    $sidebarLink.on('click', function (e) {
        e.preventDefault();

        const linkAnchor = $(this).html().toLowerCase();
        $sidebarLink.parent().removeClass('active');
        $(this).parent().addClass('active');
        $([document.documentElement, document.body]).animate(
            {
                scrollTop: $(`[data-id="${linkAnchor}"]`).offset().top - 30,
            },
            1000
        );
    });

    // PLP

    // Load Posts
    if ($('body').hasClass('template-collection')) {
        function getProducts(numberOfPages, i, $collectionGrid) {
            const searchUrl = window.location.search;
            let nextPageUrl = `${window.location.pathname}?page=${i}`;

            if (searchUrl !== '') {
                nextPageUrl += `&${searchUrl.replace('?', '')}`;
            }

            $.get(nextPageUrl, (data) => {
                const products = $(data).find('#collection').html();

                $collectionGrid.append(products);
                swatchSelector();

                if (i + 1 <= numberOfPages) {
                    getProducts(numberOfPages, i + 1, $collectionGrid);
                }
            });
        }

        const $collectionPlp = $('[data-section-type="collection-template"]');
        const $collectionPlpGrid = $collectionPlp.find('#collection');
        const numberOfPages = parseInt($collectionPlp.data('pages'));

        if (numberOfPages > 1) {
            getProducts(numberOfPages, 2, $collectionPlpGrid);
        }
    }

    // Price Slider
    // Ion.RangeSlider, 2.3.0, © Denis Ineshin, 2010 - 2018, IonDen.com, Build date: 2018-12-12 00:00:37
    !(function (i) {
        !jQuery && typeof define === 'function' && define.amd
            ? define(['jquery'], (t) => {
                  return i(t, document, window, navigator);
              })
            : jQuery || typeof exports !== 'object'
            ? i(jQuery, document, window, navigator)
            : i(require('jquery'), document, window, navigator);
    })((a, c, l, t, _) => {
        let i;
        let s;
        let o = 0;
        const e =
            ((i = t.userAgent),
            (s = /msie\s\d+/i),
            i.search(s) > 0 &&
                s.exec(i).toString().split(' ')[1] < 9 &&
                (a('html').addClass('lt-ie9'), !0));
        Function.prototype.bind ||
            (Function.prototype.bind = function (o) {
                const e = this;
                const h = [].slice;
                if (typeof e !== 'function') {
                    throw new TypeError();
                }
                const r = h.call(arguments, 1);
                var n = function () {
                    if (this instanceof n) {
                        const t = function () {};
                        t.prototype = e.prototype;
                        const i = new t();
                        const s = e.apply(i, r.concat(h.call(arguments)));
                        return Object(s) === s ? s : i;
                    }
                    return e.apply(o, r.concat(h.call(arguments)));
                };
                return n;
            }),
            Array.prototype.indexOf ||
                (Array.prototype.indexOf = function (t, i) {
                    let s;
                    if (this == null) {
                        throw new TypeError('"this" is null or not defined');
                    }
                    const o = Object(this);
                    const e = o.length >>> 0;
                    if (e === 0) {
                        return -1;
                    }
                    let h = Number(i) || 0;
                    if ((Math.abs(h) === 1 / 0 && (h = 0), e <= h)) {
                        return -1;
                    }
                    for (
                        s = Math.max(h >= 0 ? h : e - Math.abs(h), 0);
                        s < e;

                    ) {
                        if (s in o && o[s] === t) {
                            return s;
                        }
                        s++;
                    }
                    return -1;
                });
        const h = function (t, i, s) {
            (this.VERSION = '2.3.0'),
                (this.input = t),
                (this.plugin_count = s),
                (this.current_plugin = 0),
                (this.calc_count = 0),
                (this.update_tm = 0),
                (this.old_from = 0),
                (this.old_to = 0),
                (this.old_min_interval = null),
                (this.raf_id = null),
                (this.dragging = !1),
                (this.force_redraw = !1),
                (this.no_diapason = !1),
                (this.has_tab_index = !0),
                (this.is_key = !1),
                (this.is_update = !1),
                (this.is_start = !0),
                (this.is_finish = !1),
                (this.is_active = !1),
                (this.is_resize = !1),
                (this.is_click = !1),
                (i = i || {}),
                (this.$cache = {
                    win: a(l),
                    body: a(c.body),
                    input: a(t),
                    cont: null,
                    rs: null,
                    min: null,
                    max: null,
                    from: null,
                    to: null,
                    single: null,
                    bar: null,
                    line: null,
                    s_single: null,
                    s_from: null,
                    s_to: null,
                    shad_single: null,
                    shad_from: null,
                    shad_to: null,
                    edge: null,
                    grid: null,
                    grid_labels: [],
                }),
                (this.coords = {
                    x_gap: 0,
                    x_pointer: 0,
                    w_rs: 0,
                    w_rs_old: 0,
                    w_handle: 0,
                    p_gap: 0,
                    p_gap_left: 0,
                    p_gap_right: 0,
                    p_step: 0,
                    p_pointer: 0,
                    p_handle: 0,
                    p_single_fake: 0,
                    p_single_real: 0,
                    p_from_fake: 0,
                    p_from_real: 0,
                    p_to_fake: 0,
                    p_to_real: 0,
                    p_bar_x: 0,
                    p_bar_w: 0,
                    grid_gap: 0,
                    big_num: 0,
                    big: [],
                    big_w: [],
                    big_p: [],
                    big_x: [],
                }),
                (this.labels = {
                    w_min: 0,
                    w_max: 0,
                    w_from: 0,
                    w_to: 0,
                    w_single: 0,
                    p_min: 0,
                    p_max: 0,
                    p_from_fake: 0,
                    p_from_left: 0,
                    p_to_fake: 0,
                    p_to_left: 0,
                    p_single_fake: 0,
                    p_single_left: 0,
                });
            let o;
            let e;
            let h;
            const r = this.$cache.input;
            let n = r.prop('value');
            for (h in ((o = {
                skin: 'flat',
                type: 'single',
                min: 10,
                max: 100,
                from: null,
                to: null,
                step: 1,
                min_interval: 0,
                max_interval: 0,
                drag_interval: !1,
                values: [],
                p_values: [],
                from_fixed: !1,
                from_min: null,
                from_max: null,
                from_shadow: !1,
                to_fixed: !1,
                to_min: null,
                to_max: null,
                to_shadow: !1,
                prettify_enabled: !0,
                prettify_separator: ' ',
                prettify: null,
                force_edges: !1,
                keyboard: !0,
                grid: !1,
                grid_margin: !0,
                grid_num: 4,
                grid_snap: !1,
                hide_min_max: !1,
                hide_from_to: !1,
                prefix: '',
                postfix: '',
                max_postfix: '',
                decorate_both: !0,
                values_separator: ' — ',
                input_values_separator: ';',
                disable: !1,
                block: !1,
                extra_classes: '',
                scope: null,
                onStart: null,
                onChange: null,
                onFinish: null,
                onUpdate: null,
            }),
            r[0].nodeName !== 'INPUT' &&
                console &&
                console.warn &&
                console.warn('Base element should be <input>!', r[0]),
            ((e = {
                skin: r.data('skin'),
                type: r.data('type'),
                min: r.data('min'),
                max: r.data('max'),
                from: r.data('from'),
                to: r.data('to'),
                step: r.data('step'),
                min_interval: r.data('minInterval'),
                max_interval: r.data('maxInterval'),
                drag_interval: r.data('dragInterval'),
                values: r.data('values'),
                from_fixed: r.data('fromFixed'),
                from_min: r.data('fromMin'),
                from_max: r.data('fromMax'),
                from_shadow: r.data('fromShadow'),
                to_fixed: r.data('toFixed'),
                to_min: r.data('toMin'),
                to_max: r.data('toMax'),
                to_shadow: r.data('toShadow'),
                prettify_enabled: r.data('prettifyEnabled'),
                prettify_separator: r.data('prettifySeparator'),
                force_edges: r.data('forceEdges'),
                keyboard: r.data('keyboard'),
                grid: r.data('grid'),
                grid_margin: r.data('gridMargin'),
                grid_num: r.data('gridNum'),
                grid_snap: r.data('gridSnap'),
                hide_min_max: r.data('hideMinMax'),
                hide_from_to: r.data('hideFromTo'),
                prefix: r.data('prefix'),
                postfix: r.data('postfix'),
                max_postfix: r.data('maxPostfix'),
                decorate_both: r.data('decorateBoth'),
                values_separator: r.data('valuesSeparator'),
                input_values_separator: r.data('inputValuesSeparator'),
                disable: r.data('disable'),
                block: r.data('block'),
                extra_classes: r.data('extraClasses'),
            }).values = e.values && e.values.split(',')),
            e)) {
                e.hasOwnProperty(h) &&
                    ((e[h] !== _ && e[h] !== '') || delete e[h]);
            }
            n !== _ &&
                n !== '' &&
                ((n = n.split(
                    e.input_values_separator || i.input_values_separator || ';'
                ))[0] &&
                    n[0] == Number(n[0]) &&
                    (n[0] = Number(n[0])),
                n[1] && n[1] == Number(n[1]) && (n[1] = Number(n[1])),
                i && i.values && i.values.length
                    ? ((o.from = n[0] && i.values.indexOf(n[0])),
                      (o.to = n[1] && i.values.indexOf(n[1])))
                    : ((o.from = n[0] && Number(n[0])),
                      (o.to = n[1] && Number(n[1])))),
                a.extend(o, i),
                a.extend(o, e),
                (this.options = o),
                (this.update_check = {}),
                this.validate(),
                (this.result = {
                    input: this.$cache.input,
                    slider: null,
                    min: this.options.min,
                    max: this.options.max,
                    from: this.options.from,
                    from_percent: 0,
                    from_value: null,
                    to: this.options.to,
                    to_percent: 0,
                    to_value: null,
                }),
                this.init();
        };
        (h.prototype = {
            init(t) {
                (this.no_diapason = !1),
                    (this.coords.p_step = this.convertToPercent(
                        this.options.step,
                        !0
                    )),
                    (this.target = 'base'),
                    this.toggleInput(),
                    this.append(),
                    this.setMinMax(),
                    t
                        ? ((this.force_redraw = !0),
                          this.calc(!0),
                          this.callOnUpdate())
                        : ((this.force_redraw = !0),
                          this.calc(!0),
                          this.callOnStart()),
                    this.updateScene();
            },
            append() {
                const t = `<span class="irs irs--${this.options.skin} js-irs-${this.plugin_count} ${this.options.extra_classes}"></span>`;
                this.$cache.input.before(t),
                    this.$cache.input.prop('readonly', !0),
                    (this.$cache.cont = this.$cache.input.prev()),
                    (this.result.slider = this.$cache.cont),
                    this.$cache.cont.html(
                        '<span class="irs"><span class="irs-line" tabindex="0"></span><span class="irs-min">0</span><span class="irs-max">1</span><span class="irs-from">0</span><span class="irs-to">0</span><span class="irs-single">0</span></span><span class="irs-grid"></span>'
                    ),
                    (this.$cache.rs = this.$cache.cont.find('.irs')),
                    (this.$cache.min = this.$cache.cont.find('.irs-min')),
                    (this.$cache.max = this.$cache.cont.find('.irs-max')),
                    (this.$cache.from = this.$cache.cont.find('.irs-from')),
                    (this.$cache.to = this.$cache.cont.find('.irs-to')),
                    (this.$cache.single = this.$cache.cont.find('.irs-single')),
                    (this.$cache.line = this.$cache.cont.find('.irs-line')),
                    (this.$cache.grid = this.$cache.cont.find('.irs-grid')),
                    this.options.type === 'single'
                        ? (this.$cache.cont.append(
                              '<span class="irs-bar irs-bar--single"></span><span class="irs-shadow shadow-single"></span><span class="irs-handle single"><i></i><i></i><i></i></span>'
                          ),
                          (this.$cache.bar = this.$cache.cont.find('.irs-bar')),
                          (this.$cache.edge =
                              this.$cache.cont.find('.irs-bar-edge')),
                          (this.$cache.s_single =
                              this.$cache.cont.find('.single')),
                          (this.$cache.from[0].style.visibility = 'hidden'),
                          (this.$cache.to[0].style.visibility = 'hidden'),
                          (this.$cache.shad_single =
                              this.$cache.cont.find('.shadow-single')))
                        : (this.$cache.cont.append(
                              '<span class="irs-bar"></span><span class="irs-shadow shadow-from"></span><span class="irs-shadow shadow-to"></span><span class="irs-handle from"><i></i><i></i><i></i></span><span class="irs-handle to"><i></i><i></i><i></i></span>'
                          ),
                          (this.$cache.bar = this.$cache.cont.find('.irs-bar')),
                          (this.$cache.s_from = this.$cache.cont.find('.from')),
                          (this.$cache.s_to = this.$cache.cont.find('.to')),
                          (this.$cache.shad_from =
                              this.$cache.cont.find('.shadow-from')),
                          (this.$cache.shad_to =
                              this.$cache.cont.find('.shadow-to')),
                          this.setTopHandler()),
                    this.options.hide_from_to &&
                        ((this.$cache.from[0].style.display = 'none'),
                        (this.$cache.to[0].style.display = 'none'),
                        (this.$cache.single[0].style.display = 'none')),
                    this.appendGrid(),
                    this.options.disable
                        ? (this.appendDisableMask(),
                          (this.$cache.input[0].disabled = !0))
                        : ((this.$cache.input[0].disabled = !1),
                          this.removeDisableMask(),
                          this.bindEvents()),
                    this.options.disable ||
                        (this.options.block
                            ? this.appendDisableMask()
                            : this.removeDisableMask()),
                    this.options.drag_interval &&
                        (this.$cache.bar[0].style.cursor = 'ew-resize');
            },
            setTopHandler() {
                const t = this.options.min;
                const i = this.options.max;
                const s = this.options.from;
                const o = this.options.to;
                t < s && o === i
                    ? this.$cache.s_from.addClass('type_last')
                    : o < i && this.$cache.s_to.addClass('type_last');
            },
            changeLevel(t) {
                switch (t) {
                    case 'single':
                        (this.coords.p_gap = this.toFixed(
                            this.coords.p_pointer - this.coords.p_single_fake
                        )),
                            this.$cache.s_single.addClass('state_hover');
                        break;
                    case 'from':
                        (this.coords.p_gap = this.toFixed(
                            this.coords.p_pointer - this.coords.p_from_fake
                        )),
                            this.$cache.s_from.addClass('state_hover'),
                            this.$cache.s_from.addClass('type_last'),
                            this.$cache.s_to.removeClass('type_last');
                        break;
                    case 'to':
                        (this.coords.p_gap = this.toFixed(
                            this.coords.p_pointer - this.coords.p_to_fake
                        )),
                            this.$cache.s_to.addClass('state_hover'),
                            this.$cache.s_to.addClass('type_last'),
                            this.$cache.s_from.removeClass('type_last');
                        break;
                    case 'both':
                        (this.coords.p_gap_left = this.toFixed(
                            this.coords.p_pointer - this.coords.p_from_fake
                        )),
                            (this.coords.p_gap_right = this.toFixed(
                                this.coords.p_to_fake - this.coords.p_pointer
                            )),
                            this.$cache.s_to.removeClass('type_last'),
                            this.$cache.s_from.removeClass('type_last');
                }
            },
            appendDisableMask() {
                this.$cache.cont.append(
                    '<span class="irs-disable-mask"></span>'
                ),
                    this.$cache.cont.addClass('irs-disabled');
            },
            removeDisableMask() {
                this.$cache.cont.remove('.irs-disable-mask'),
                    this.$cache.cont.removeClass('irs-disabled');
            },
            remove() {
                this.$cache.cont.remove(),
                    (this.$cache.cont = null),
                    this.$cache.line.off(`keydown.irs_${this.plugin_count}`),
                    this.$cache.body.off(`touchmove.irs_${this.plugin_count}`),
                    this.$cache.body.off(`mousemove.irs_${this.plugin_count}`),
                    this.$cache.win.off(`touchend.irs_${this.plugin_count}`),
                    this.$cache.win.off(`mouseup.irs_${this.plugin_count}`),
                    e &&
                        (this.$cache.body.off(
                            `mouseup.irs_${this.plugin_count}`
                        ),
                        this.$cache.body.off(
                            `mouseleave.irs_${this.plugin_count}`
                        )),
                    (this.$cache.grid_labels = []),
                    (this.coords.big = []),
                    (this.coords.big_w = []),
                    (this.coords.big_p = []),
                    (this.coords.big_x = []),
                    cancelAnimationFrame(this.raf_id);
            },
            bindEvents() {
                this.no_diapason ||
                    (this.$cache.body.on(
                        `touchmove.irs_${this.plugin_count}`,
                        this.pointerMove.bind(this)
                    ),
                    this.$cache.body.on(
                        `mousemove.irs_${this.plugin_count}`,
                        this.pointerMove.bind(this)
                    ),
                    this.$cache.win.on(
                        `touchend.irs_${this.plugin_count}`,
                        this.pointerUp.bind(this)
                    ),
                    this.$cache.win.on(
                        `mouseup.irs_${this.plugin_count}`,
                        this.pointerUp.bind(this)
                    ),
                    this.$cache.line.on(
                        `touchstart.irs_${this.plugin_count}`,
                        this.pointerClick.bind(this, 'click')
                    ),
                    this.$cache.line.on(
                        `mousedown.irs_${this.plugin_count}`,
                        this.pointerClick.bind(this, 'click')
                    ),
                    this.$cache.line.on(
                        `focus.irs_${this.plugin_count}`,
                        this.pointerFocus.bind(this)
                    ),
                    this.options.drag_interval && this.options.type === 'double'
                        ? (this.$cache.bar.on(
                              `touchstart.irs_${this.plugin_count}`,
                              this.pointerDown.bind(this, 'both')
                          ),
                          this.$cache.bar.on(
                              `mousedown.irs_${this.plugin_count}`,
                              this.pointerDown.bind(this, 'both')
                          ))
                        : (this.$cache.bar.on(
                              `touchstart.irs_${this.plugin_count}`,
                              this.pointerClick.bind(this, 'click')
                          ),
                          this.$cache.bar.on(
                              `mousedown.irs_${this.plugin_count}`,
                              this.pointerClick.bind(this, 'click')
                          )),
                    this.options.type === 'single'
                        ? (this.$cache.single.on(
                              `touchstart.irs_${this.plugin_count}`,
                              this.pointerDown.bind(this, 'single')
                          ),
                          this.$cache.s_single.on(
                              `touchstart.irs_${this.plugin_count}`,
                              this.pointerDown.bind(this, 'single')
                          ),
                          this.$cache.shad_single.on(
                              `touchstart.irs_${this.plugin_count}`,
                              this.pointerClick.bind(this, 'click')
                          ),
                          this.$cache.single.on(
                              `mousedown.irs_${this.plugin_count}`,
                              this.pointerDown.bind(this, 'single')
                          ),
                          this.$cache.s_single.on(
                              `mousedown.irs_${this.plugin_count}`,
                              this.pointerDown.bind(this, 'single')
                          ),
                          this.$cache.edge.on(
                              `mousedown.irs_${this.plugin_count}`,
                              this.pointerClick.bind(this, 'click')
                          ),
                          this.$cache.shad_single.on(
                              `mousedown.irs_${this.plugin_count}`,
                              this.pointerClick.bind(this, 'click')
                          ))
                        : (this.$cache.single.on(
                              `touchstart.irs_${this.plugin_count}`,
                              this.pointerDown.bind(this, null)
                          ),
                          this.$cache.single.on(
                              `mousedown.irs_${this.plugin_count}`,
                              this.pointerDown.bind(this, null)
                          ),
                          this.$cache.from.on(
                              `touchstart.irs_${this.plugin_count}`,
                              this.pointerDown.bind(this, 'from')
                          ),
                          this.$cache.s_from.on(
                              `touchstart.irs_${this.plugin_count}`,
                              this.pointerDown.bind(this, 'from')
                          ),
                          this.$cache.to.on(
                              `touchstart.irs_${this.plugin_count}`,
                              this.pointerDown.bind(this, 'to')
                          ),
                          this.$cache.s_to.on(
                              `touchstart.irs_${this.plugin_count}`,
                              this.pointerDown.bind(this, 'to')
                          ),
                          this.$cache.shad_from.on(
                              `touchstart.irs_${this.plugin_count}`,
                              this.pointerClick.bind(this, 'click')
                          ),
                          this.$cache.shad_to.on(
                              `touchstart.irs_${this.plugin_count}`,
                              this.pointerClick.bind(this, 'click')
                          ),
                          this.$cache.from.on(
                              `mousedown.irs_${this.plugin_count}`,
                              this.pointerDown.bind(this, 'from')
                          ),
                          this.$cache.s_from.on(
                              `mousedown.irs_${this.plugin_count}`,
                              this.pointerDown.bind(this, 'from')
                          ),
                          this.$cache.to.on(
                              `mousedown.irs_${this.plugin_count}`,
                              this.pointerDown.bind(this, 'to')
                          ),
                          this.$cache.s_to.on(
                              `mousedown.irs_${this.plugin_count}`,
                              this.pointerDown.bind(this, 'to')
                          ),
                          this.$cache.shad_from.on(
                              `mousedown.irs_${this.plugin_count}`,
                              this.pointerClick.bind(this, 'click')
                          ),
                          this.$cache.shad_to.on(
                              `mousedown.irs_${this.plugin_count}`,
                              this.pointerClick.bind(this, 'click')
                          )),
                    this.options.keyboard &&
                        this.$cache.line.on(
                            `keydown.irs_${this.plugin_count}`,
                            this.key.bind(this, 'keyboard')
                        ),
                    e &&
                        (this.$cache.body.on(
                            `mouseup.irs_${this.plugin_count}`,
                            this.pointerUp.bind(this)
                        ),
                        this.$cache.body.on(
                            `mouseleave.irs_${this.plugin_count}`,
                            this.pointerUp.bind(this)
                        )));
            },
            pointerFocus(t) {
                let i;
                let s;
                this.target ||
                    ((i = (s =
                        this.options.type === 'single'
                            ? this.$cache.single
                            : this.$cache.from).offset().left),
                    (i += s.width() / 2 - 1),
                    this.pointerClick('single', {
                        preventDefault() {},
                        pageX: i,
                    }));
            },
            pointerMove(t) {
                if (this.dragging) {
                    const i =
                        t.pageX ||
                        (t.originalEvent.touches &&
                            t.originalEvent.touches[0].pageX);
                    (this.coords.x_pointer = i - this.coords.x_gap),
                        this.calc();
                }
            },
            pointerUp(t) {
                this.current_plugin === this.plugin_count &&
                    this.is_active &&
                    ((this.is_active = !1),
                    this.$cache.cont
                        .find('.state_hover')
                        .removeClass('state_hover'),
                    (this.force_redraw = !0),
                    e && a('*').prop('unselectable', !1),
                    this.updateScene(),
                    this.restoreOriginalMinInterval(),
                    (a.contains(this.$cache.cont[0], t.target) ||
                        this.dragging) &&
                        this.callOnFinish(),
                    (this.dragging = !1));
            },
            pointerDown(t, i) {
                i.preventDefault();
                const s =
                    i.pageX ||
                    (i.originalEvent.touches &&
                        i.originalEvent.touches[0].pageX);
                i.button !== 2 &&
                    (t === 'both' && this.setTempMinInterval(),
                    t || (t = this.target || 'from'),
                    (this.current_plugin = this.plugin_count),
                    (this.target = t),
                    (this.is_active = !0),
                    (this.dragging = !0),
                    (this.coords.x_gap = this.$cache.rs.offset().left),
                    (this.coords.x_pointer = s - this.coords.x_gap),
                    this.calcPointerPercent(),
                    this.changeLevel(t),
                    e && a('*').prop('unselectable', !0),
                    this.$cache.line.trigger('focus'),
                    this.updateScene());
            },
            pointerClick(t, i) {
                i.preventDefault();
                const s =
                    i.pageX ||
                    (i.originalEvent.touches &&
                        i.originalEvent.touches[0].pageX);
                i.button !== 2 &&
                    ((this.current_plugin = this.plugin_count),
                    (this.target = t),
                    (this.is_click = !0),
                    (this.coords.x_gap = this.$cache.rs.offset().left),
                    (this.coords.x_pointer = Number(
                        (s - this.coords.x_gap).toFixed()
                    )),
                    (this.force_redraw = !0),
                    this.calc(),
                    this.$cache.line.trigger('focus'));
            },
            key(t, i) {
                if (
                    !(
                        this.current_plugin !== this.plugin_count ||
                        i.altKey ||
                        i.ctrlKey ||
                        i.shiftKey ||
                        i.metaKey
                    )
                ) {
                    switch (i.which) {
                        case 83:
                        case 65:
                        case 40:
                        case 37:
                            i.preventDefault(), this.moveByKey(!1);
                            break;
                        case 87:
                        case 68:
                        case 38:
                        case 39:
                            i.preventDefault(), this.moveByKey(!0);
                    }
                    return !0;
                }
            },
            moveByKey(t) {
                let i = this.coords.p_pointer;
                let s = (this.options.max - this.options.min) / 100;
                (s = this.options.step / s),
                    t ? (i += s) : (i -= s),
                    (this.coords.x_pointer = this.toFixed(
                        (this.coords.w_rs / 100) * i
                    )),
                    (this.is_key = !0),
                    this.calc();
            },
            setMinMax() {
                if (this.options) {
                    if (this.options.hide_min_max) {
                        return (
                            (this.$cache.min[0].style.display = 'none'),
                            void (this.$cache.max[0].style.display = 'none')
                        );
                    }
                    if (this.options.values.length) {
                        this.$cache.min.html(
                            this.decorate(
                                this.options.p_values[this.options.min]
                            )
                        ),
                            this.$cache.max.html(
                                this.decorate(
                                    this.options.p_values[this.options.max]
                                )
                            );
                    } else {
                        const t = this._prettify(this.options.min);
                        const i = this._prettify(this.options.max);
                        (this.result.min_pretty = t),
                            (this.result.max_pretty = i),
                            this.$cache.min.html(
                                this.decorate(t, this.options.min)
                            ),
                            this.$cache.max.html(
                                this.decorate(i, this.options.max)
                            );
                    }
                    (this.labels.w_min = this.$cache.min.outerWidth(!1)),
                        (this.labels.w_max = this.$cache.max.outerWidth(!1));
                }
            },
            setTempMinInterval() {
                const t = this.result.to - this.result.from;
                this.old_min_interval === null &&
                    (this.old_min_interval = this.options.min_interval),
                    (this.options.min_interval = t);
            },
            restoreOriginalMinInterval() {
                this.old_min_interval !== null &&
                    ((this.options.min_interval = this.old_min_interval),
                    (this.old_min_interval = null));
            },
            calc(t) {
                if (
                    this.options &&
                    (this.calc_count++,
                    (this.calc_count === 10 || t) &&
                        ((this.calc_count = 0),
                        (this.coords.w_rs = this.$cache.rs.outerWidth(!1)),
                        this.calcHandlePercent()),
                    this.coords.w_rs)
                ) {
                    this.calcPointerPercent();
                    let i = this.getHandleX();
                    switch (
                        (this.target === 'both' &&
                            ((this.coords.p_gap = 0), (i = this.getHandleX())),
                        this.target === 'click' &&
                            ((this.coords.p_gap = this.coords.p_handle / 2),
                            (i = this.getHandleX()),
                            this.options.drag_interval
                                ? (this.target = 'both_one')
                                : (this.target = this.chooseHandle(i))),
                        this.target)
                    ) {
                        case 'base':
                            var s = (this.options.max - this.options.min) / 100;
                            var o = (this.result.from - this.options.min) / s;
                            var e = (this.result.to - this.options.min) / s;
                            (this.coords.p_single_real = this.toFixed(o)),
                                (this.coords.p_from_real = this.toFixed(o)),
                                (this.coords.p_to_real = this.toFixed(e)),
                                (this.coords.p_single_real = this.checkDiapason(
                                    this.coords.p_single_real,
                                    this.options.from_min,
                                    this.options.from_max
                                )),
                                (this.coords.p_from_real = this.checkDiapason(
                                    this.coords.p_from_real,
                                    this.options.from_min,
                                    this.options.from_max
                                )),
                                (this.coords.p_to_real = this.checkDiapason(
                                    this.coords.p_to_real,
                                    this.options.to_min,
                                    this.options.to_max
                                )),
                                (this.coords.p_single_fake =
                                    this.convertToFakePercent(
                                        this.coords.p_single_real
                                    )),
                                (this.coords.p_from_fake =
                                    this.convertToFakePercent(
                                        this.coords.p_from_real
                                    )),
                                (this.coords.p_to_fake =
                                    this.convertToFakePercent(
                                        this.coords.p_to_real
                                    )),
                                (this.target = null);
                            break;
                        case 'single':
                            if (this.options.from_fixed) {
                                break;
                            }
                            (this.coords.p_single_real =
                                this.convertToRealPercent(i)),
                                (this.coords.p_single_real = this.calcWithStep(
                                    this.coords.p_single_real
                                )),
                                (this.coords.p_single_real = this.checkDiapason(
                                    this.coords.p_single_real,
                                    this.options.from_min,
                                    this.options.from_max
                                )),
                                (this.coords.p_single_fake =
                                    this.convertToFakePercent(
                                        this.coords.p_single_real
                                    ));
                            break;
                        case 'from':
                            if (this.options.from_fixed) {
                                break;
                            }
                            (this.coords.p_from_real =
                                this.convertToRealPercent(i)),
                                (this.coords.p_from_real = this.calcWithStep(
                                    this.coords.p_from_real
                                )),
                                this.coords.p_from_real >
                                    this.coords.p_to_real &&
                                    (this.coords.p_from_real =
                                        this.coords.p_to_real),
                                (this.coords.p_from_real = this.checkDiapason(
                                    this.coords.p_from_real,
                                    this.options.from_min,
                                    this.options.from_max
                                )),
                                (this.coords.p_from_real =
                                    this.checkMinInterval(
                                        this.coords.p_from_real,
                                        this.coords.p_to_real,
                                        'from'
                                    )),
                                (this.coords.p_from_real =
                                    this.checkMaxInterval(
                                        this.coords.p_from_real,
                                        this.coords.p_to_real,
                                        'from'
                                    )),
                                (this.coords.p_from_fake =
                                    this.convertToFakePercent(
                                        this.coords.p_from_real
                                    ));
                            break;
                        case 'to':
                            if (this.options.to_fixed) {
                                break;
                            }
                            (this.coords.p_to_real =
                                this.convertToRealPercent(i)),
                                (this.coords.p_to_real = this.calcWithStep(
                                    this.coords.p_to_real
                                )),
                                this.coords.p_to_real <
                                    this.coords.p_from_real &&
                                    (this.coords.p_to_real =
                                        this.coords.p_from_real),
                                (this.coords.p_to_real = this.checkDiapason(
                                    this.coords.p_to_real,
                                    this.options.to_min,
                                    this.options.to_max
                                )),
                                (this.coords.p_to_real = this.checkMinInterval(
                                    this.coords.p_to_real,
                                    this.coords.p_from_real,
                                    'to'
                                )),
                                (this.coords.p_to_real = this.checkMaxInterval(
                                    this.coords.p_to_real,
                                    this.coords.p_from_real,
                                    'to'
                                )),
                                (this.coords.p_to_fake =
                                    this.convertToFakePercent(
                                        this.coords.p_to_real
                                    ));
                            break;
                        case 'both':
                            if (
                                this.options.from_fixed ||
                                this.options.to_fixed
                            ) {
                                break;
                            }
                            (i = this.toFixed(
                                i + 0.001 * this.coords.p_handle
                            )),
                                (this.coords.p_from_real =
                                    this.convertToRealPercent(i) -
                                    this.coords.p_gap_left),
                                (this.coords.p_from_real = this.calcWithStep(
                                    this.coords.p_from_real
                                )),
                                (this.coords.p_from_real = this.checkDiapason(
                                    this.coords.p_from_real,
                                    this.options.from_min,
                                    this.options.from_max
                                )),
                                (this.coords.p_from_real =
                                    this.checkMinInterval(
                                        this.coords.p_from_real,
                                        this.coords.p_to_real,
                                        'from'
                                    )),
                                (this.coords.p_from_fake =
                                    this.convertToFakePercent(
                                        this.coords.p_from_real
                                    )),
                                (this.coords.p_to_real =
                                    this.convertToRealPercent(i) +
                                    this.coords.p_gap_right),
                                (this.coords.p_to_real = this.calcWithStep(
                                    this.coords.p_to_real
                                )),
                                (this.coords.p_to_real = this.checkDiapason(
                                    this.coords.p_to_real,
                                    this.options.to_min,
                                    this.options.to_max
                                )),
                                (this.coords.p_to_real = this.checkMinInterval(
                                    this.coords.p_to_real,
                                    this.coords.p_from_real,
                                    'to'
                                )),
                                (this.coords.p_to_fake =
                                    this.convertToFakePercent(
                                        this.coords.p_to_real
                                    ));
                            break;
                        case 'both_one':
                            if (
                                this.options.from_fixed ||
                                this.options.to_fixed
                            ) {
                                break;
                            }
                            var h = this.convertToRealPercent(i);
                            var r = this.result.from_percent;
                            var n = this.result.to_percent - r;
                            var a = n / 2;
                            var c = h - a;
                            var l = h + a;
                            c < 0 && (l = (c = 0) + n),
                                l > 100 && (c = (l = 100) - n),
                                (this.coords.p_from_real =
                                    this.calcWithStep(c)),
                                (this.coords.p_from_real = this.checkDiapason(
                                    this.coords.p_from_real,
                                    this.options.from_min,
                                    this.options.from_max
                                )),
                                (this.coords.p_from_fake =
                                    this.convertToFakePercent(
                                        this.coords.p_from_real
                                    )),
                                (this.coords.p_to_real = this.calcWithStep(l)),
                                (this.coords.p_to_real = this.checkDiapason(
                                    this.coords.p_to_real,
                                    this.options.to_min,
                                    this.options.to_max
                                )),
                                (this.coords.p_to_fake =
                                    this.convertToFakePercent(
                                        this.coords.p_to_real
                                    ));
                    }
                    this.options.type === 'single'
                        ? ((this.coords.p_bar_x = this.coords.p_handle / 2),
                          (this.coords.p_bar_w = this.coords.p_single_fake),
                          (this.result.from_percent =
                              this.coords.p_single_real),
                          (this.result.from = this.convertToValue(
                              this.coords.p_single_real
                          )),
                          (this.result.from_pretty = this._prettify(
                              this.result.from
                          )),
                          this.options.values.length &&
                              (this.result.from_value =
                                  this.options.values[this.result.from]))
                        : ((this.coords.p_bar_x = this.toFixed(
                              this.coords.p_from_fake + this.coords.p_handle / 2
                          )),
                          (this.coords.p_bar_w = this.toFixed(
                              this.coords.p_to_fake - this.coords.p_from_fake
                          )),
                          (this.result.from_percent = this.coords.p_from_real),
                          (this.result.from = this.convertToValue(
                              this.coords.p_from_real
                          )),
                          (this.result.from_pretty = this._prettify(
                              this.result.from
                          )),
                          (this.result.to_percent = this.coords.p_to_real),
                          (this.result.to = this.convertToValue(
                              this.coords.p_to_real
                          )),
                          (this.result.to_pretty = this._prettify(
                              this.result.to
                          )),
                          this.options.values.length &&
                              ((this.result.from_value =
                                  this.options.values[this.result.from]),
                              (this.result.to_value =
                                  this.options.values[this.result.to]))),
                        this.calcMinMax(),
                        this.calcLabels();
                }
            },
            calcPointerPercent() {
                this.coords.w_rs
                    ? (this.coords.x_pointer < 0 || isNaN(this.coords.x_pointer)
                          ? (this.coords.x_pointer = 0)
                          : this.coords.x_pointer > this.coords.w_rs &&
                            (this.coords.x_pointer = this.coords.w_rs),
                      (this.coords.p_pointer = this.toFixed(
                          (this.coords.x_pointer / this.coords.w_rs) * 100
                      )))
                    : (this.coords.p_pointer = 0);
            },
            convertToRealPercent(t) {
                return (t / (100 - this.coords.p_handle)) * 100;
            },
            convertToFakePercent(t) {
                return (t / 100) * (100 - this.coords.p_handle);
            },
            getHandleX() {
                const t = 100 - this.coords.p_handle;
                let i = this.toFixed(this.coords.p_pointer - this.coords.p_gap);
                return i < 0 ? (i = 0) : t < i && (i = t), i;
            },
            calcHandlePercent() {
                this.options.type === 'single'
                    ? (this.coords.w_handle = this.$cache.s_single.outerWidth(
                          !1
                      ))
                    : (this.coords.w_handle = this.$cache.s_from.outerWidth(
                          !1
                      )),
                    (this.coords.p_handle = this.toFixed(
                        (this.coords.w_handle / this.coords.w_rs) * 100
                    ));
            },
            chooseHandle(t) {
                return this.options.type === 'single'
                    ? 'single'
                    : this.coords.p_from_real +
                          (this.coords.p_to_real - this.coords.p_from_real) /
                              2 <=
                      t
                    ? this.options.to_fixed
                        ? 'from'
                        : 'to'
                    : this.options.from_fixed
                    ? 'to'
                    : 'from';
            },
            calcMinMax() {
                this.coords.w_rs &&
                    ((this.labels.p_min =
                        (this.labels.w_min / this.coords.w_rs) * 100),
                    (this.labels.p_max =
                        (this.labels.w_max / this.coords.w_rs) * 100));
            },
            calcLabels() {
                this.coords.w_rs &&
                    !this.options.hide_from_to &&
                    (this.options.type === 'single'
                        ? ((this.labels.w_single =
                              this.$cache.single.outerWidth(!1)),
                          (this.labels.p_single_fake =
                              (this.labels.w_single / this.coords.w_rs) * 100),
                          (this.labels.p_single_left =
                              this.coords.p_single_fake +
                              this.coords.p_handle / 2 -
                              this.labels.p_single_fake / 2))
                        : ((this.labels.w_from = this.$cache.from.outerWidth(
                              !1
                          )),
                          (this.labels.p_from_fake =
                              (this.labels.w_from / this.coords.w_rs) * 100),
                          (this.labels.p_from_left =
                              this.coords.p_from_fake +
                              this.coords.p_handle / 2 -
                              this.labels.p_from_fake / 2),
                          (this.labels.p_from_left = this.toFixed(
                              this.labels.p_from_left
                          )),
                          (this.labels.p_from_left = this.checkEdges(
                              this.labels.p_from_left,
                              this.labels.p_from_fake
                          )),
                          (this.labels.w_to = this.$cache.to.outerWidth(!1)),
                          (this.labels.p_to_fake =
                              (this.labels.w_to / this.coords.w_rs) * 100),
                          (this.labels.p_to_left =
                              this.coords.p_to_fake +
                              this.coords.p_handle / 2 -
                              this.labels.p_to_fake / 2),
                          (this.labels.p_to_left = this.toFixed(
                              this.labels.p_to_left
                          )),
                          (this.labels.p_to_left = this.checkEdges(
                              this.labels.p_to_left,
                              this.labels.p_to_fake
                          )),
                          (this.labels.w_single = this.$cache.single.outerWidth(
                              !1
                          )),
                          (this.labels.p_single_fake =
                              (this.labels.w_single / this.coords.w_rs) * 100),
                          (this.labels.p_single_left =
                              (this.labels.p_from_left +
                                  this.labels.p_to_left +
                                  this.labels.p_to_fake) /
                                  2 -
                              this.labels.p_single_fake / 2),
                          (this.labels.p_single_left = this.toFixed(
                              this.labels.p_single_left
                          ))),
                    (this.labels.p_single_left = this.checkEdges(
                        this.labels.p_single_left,
                        this.labels.p_single_fake
                    )));
            },
            updateScene() {
                this.raf_id &&
                    (cancelAnimationFrame(this.raf_id), (this.raf_id = null)),
                    clearTimeout(this.update_tm),
                    (this.update_tm = null),
                    this.options &&
                        (this.drawHandles(),
                        this.is_active
                            ? (this.raf_id = requestAnimationFrame(
                                  this.updateScene.bind(this)
                              ))
                            : (this.update_tm = setTimeout(
                                  this.updateScene.bind(this),
                                  300
                              )));
            },
            drawHandles() {
                (this.coords.w_rs = this.$cache.rs.outerWidth(!1)),
                    this.coords.w_rs &&
                        (this.coords.w_rs !== this.coords.w_rs_old &&
                            ((this.target = 'base'), (this.is_resize = !0)),
                        (this.coords.w_rs !== this.coords.w_rs_old ||
                            this.force_redraw) &&
                            (this.setMinMax(),
                            this.calc(!0),
                            this.drawLabels(),
                            this.options.grid &&
                                (this.calcGridMargin(), this.calcGridLabels()),
                            (this.force_redraw = !0),
                            (this.coords.w_rs_old = this.coords.w_rs),
                            this.drawShadow()),
                        this.coords.w_rs &&
                            (this.dragging ||
                                this.force_redraw ||
                                this.is_key) &&
                            ((this.old_from !== this.result.from ||
                                this.old_to !== this.result.to ||
                                this.force_redraw ||
                                this.is_key) &&
                                (this.drawLabels(),
                                (this.$cache.bar[0].style.left = `${this.coords.p_bar_x}%`),
                                (this.$cache.bar[0].style.width = `${this.coords.p_bar_w}%`),
                                this.options.type === 'single'
                                    ? ((this.$cache.bar[0].style.left = 0),
                                      (this.$cache.bar[0].style.width = `${
                                          this.coords.p_bar_w +
                                          this.coords.p_bar_x
                                      }%`),
                                      (this.$cache.s_single[0].style.left = `${this.coords.p_single_fake}%`))
                                    : ((this.$cache.s_from[0].style.left = `${this.coords.p_from_fake}%`),
                                      (this.$cache.s_to[0].style.left = `${this.coords.p_to_fake}%`),
                                      (this.old_from !== this.result.from ||
                                          this.force_redraw) &&
                                          (this.$cache.from[0].style.left = `${this.labels.p_from_left}%`),
                                      (this.old_to !== this.result.to ||
                                          this.force_redraw) &&
                                          (this.$cache.to[0].style.left = `${this.labels.p_to_left}%`)),
                                (this.$cache.single[0].style.left = `${this.labels.p_single_left}%`),
                                this.writeToInput(),
                                (this.old_from === this.result.from &&
                                    this.old_to === this.result.to) ||
                                    this.is_start ||
                                    (this.$cache.input.trigger('change'),
                                    this.$cache.input.trigger('input')),
                                (this.old_from = this.result.from),
                                (this.old_to = this.result.to),
                                this.is_resize ||
                                    this.is_update ||
                                    this.is_start ||
                                    this.is_finish ||
                                    this.callOnChange(),
                                (this.is_key || this.is_click) &&
                                    ((this.is_key = !1),
                                    (this.is_click = !1),
                                    this.callOnFinish()),
                                (this.is_update = !1),
                                (this.is_resize = !1),
                                (this.is_finish = !1)),
                            (this.is_start = !1),
                            (this.is_key = !1),
                            (this.is_click = !1),
                            (this.force_redraw = !1)));
            },
            drawLabels() {
                if (this.options) {
                    let t;
                    let i;
                    let s;
                    let o;
                    let e;
                    const h = this.options.values.length;
                    const r = this.options.p_values;
                    if (!this.options.hide_from_to) {
                        if (this.options.type === 'single') {
                            (t = h
                                ? this.decorate(r[this.result.from])
                                : ((o = this._prettify(this.result.from)),
                                  this.decorate(o, this.result.from))),
                                this.$cache.single.html(t),
                                this.calcLabels(),
                                this.labels.p_single_left <
                                this.labels.p_min + 1
                                    ? (this.$cache.min[0].style.visibility =
                                          'hidden')
                                    : (this.$cache.min[0].style.visibility =
                                          'visible'),
                                this.labels.p_single_left +
                                    this.labels.p_single_fake >
                                100 - this.labels.p_max - 1
                                    ? (this.$cache.max[0].style.visibility =
                                          'hidden')
                                    : (this.$cache.max[0].style.visibility =
                                          'visible');
                        } else {
                            (s = h
                                ? (this.options.decorate_both
                                      ? ((t = this.decorate(
                                            r[this.result.from]
                                        )),
                                        (t += this.options.values_separator),
                                        (t += this.decorate(r[this.result.to])))
                                      : (t = this.decorate(
                                            r[this.result.from] +
                                                this.options.values_separator +
                                                r[this.result.to]
                                        )),
                                  (i = this.decorate(r[this.result.from])),
                                  this.decorate(r[this.result.to]))
                                : ((o = this._prettify(this.result.from)),
                                  (e = this._prettify(this.result.to)),
                                  this.options.decorate_both
                                      ? ((t = this.decorate(
                                            o,
                                            this.result.from
                                        )),
                                        (t += this.options.values_separator),
                                        (t += this.decorate(e, this.result.to)))
                                      : (t = this.decorate(
                                            o +
                                                this.options.values_separator +
                                                e,
                                            this.result.to
                                        )),
                                  (i = this.decorate(o, this.result.from)),
                                  this.decorate(e, this.result.to))),
                                this.$cache.single.html(t),
                                this.$cache.from.html(i),
                                this.$cache.to.html(s),
                                this.calcLabels();
                            const n = Math.min(
                                this.labels.p_single_left,
                                this.labels.p_from_left
                            );
                            const a =
                                this.labels.p_single_left +
                                this.labels.p_single_fake;
                            const c =
                                this.labels.p_to_left + this.labels.p_to_fake;
                            let l = Math.max(a, c);
                            this.labels.p_from_left + this.labels.p_from_fake >=
                            this.labels.p_to_left
                                ? ((this.$cache.from[0].style.visibility =
                                      'hidden'),
                                  (this.$cache.to[0].style.visibility =
                                      'hidden'),
                                  (this.$cache.single[0].style.visibility =
                                      'visible'),
                                  (l =
                                      this.result.from === this.result.to
                                          ? (this.target === 'from'
                                                ? (this.$cache.from[0].style.visibility =
                                                      'visible')
                                                : this.target === 'to'
                                                ? (this.$cache.to[0].style.visibility =
                                                      'visible')
                                                : this.target ||
                                                  (this.$cache.from[0].style.visibility =
                                                      'visible'),
                                            (this.$cache.single[0].style.visibility =
                                                'hidden'),
                                            c)
                                          : ((this.$cache.from[0].style.visibility =
                                                'hidden'),
                                            (this.$cache.to[0].style.visibility =
                                                'hidden'),
                                            (this.$cache.single[0].style.visibility =
                                                'visible'),
                                            Math.max(a, c))))
                                : ((this.$cache.from[0].style.visibility =
                                      'visible'),
                                  (this.$cache.to[0].style.visibility =
                                      'visible'),
                                  (this.$cache.single[0].style.visibility =
                                      'hidden')),
                                n < this.labels.p_min + 1
                                    ? (this.$cache.min[0].style.visibility =
                                          'hidden')
                                    : (this.$cache.min[0].style.visibility =
                                          'visible'),
                                l > 100 - this.labels.p_max - 1
                                    ? (this.$cache.max[0].style.visibility =
                                          'hidden')
                                    : (this.$cache.max[0].style.visibility =
                                          'visible');
                        }
                    }
                }
            },
            drawShadow() {
                let t;
                let i;
                let s;
                let o;
                const e = this.options;
                const h = this.$cache;
                const r = typeof e.from_min === 'number' && !isNaN(e.from_min);
                const n = typeof e.from_max === 'number' && !isNaN(e.from_max);
                const a = typeof e.to_min === 'number' && !isNaN(e.to_min);
                const c = typeof e.to_max === 'number' && !isNaN(e.to_max);
                e.type === 'single'
                    ? e.from_shadow && (r || n)
                        ? ((t = this.convertToPercent(r ? e.from_min : e.min)),
                          (i =
                              this.convertToPercent(n ? e.from_max : e.max) -
                              t),
                          (t = this.toFixed(
                              t - (this.coords.p_handle / 100) * t
                          )),
                          (i = this.toFixed(
                              i - (this.coords.p_handle / 100) * i
                          )),
                          (t += this.coords.p_handle / 2),
                          (h.shad_single[0].style.display = 'block'),
                          (h.shad_single[0].style.left = `${t}%`),
                          (h.shad_single[0].style.width = `${i}%`))
                        : (h.shad_single[0].style.display = 'none')
                    : (e.from_shadow && (r || n)
                          ? ((t = this.convertToPercent(
                                r ? e.from_min : e.min
                            )),
                            (i =
                                this.convertToPercent(n ? e.from_max : e.max) -
                                t),
                            (t = this.toFixed(
                                t - (this.coords.p_handle / 100) * t
                            )),
                            (i = this.toFixed(
                                i - (this.coords.p_handle / 100) * i
                            )),
                            (t += this.coords.p_handle / 2),
                            (h.shad_from[0].style.display = 'block'),
                            (h.shad_from[0].style.left = `${t}%`),
                            (h.shad_from[0].style.width = `${i}%`))
                          : (h.shad_from[0].style.display = 'none'),
                      e.to_shadow && (a || c)
                          ? ((s = this.convertToPercent(a ? e.to_min : e.min)),
                            (o =
                                this.convertToPercent(c ? e.to_max : e.max) -
                                s),
                            (s = this.toFixed(
                                s - (this.coords.p_handle / 100) * s
                            )),
                            (o = this.toFixed(
                                o - (this.coords.p_handle / 100) * o
                            )),
                            (s += this.coords.p_handle / 2),
                            (h.shad_to[0].style.display = 'block'),
                            (h.shad_to[0].style.left = `${s}%`),
                            (h.shad_to[0].style.width = `${o}%`))
                          : (h.shad_to[0].style.display = 'none'));
            },
            writeToInput() {
                this.options.type === 'single'
                    ? (this.options.values.length
                          ? this.$cache.input.prop(
                                'value',
                                this.result.from_value
                            )
                          : this.$cache.input.prop('value', this.result.from),
                      this.$cache.input.data('from', this.result.from))
                    : (this.options.values.length
                          ? this.$cache.input.prop(
                                'value',
                                this.result.from_value +
                                    this.options.input_values_separator +
                                    this.result.to_value
                            )
                          : this.$cache.input.prop(
                                'value',
                                this.result.from +
                                    this.options.input_values_separator +
                                    this.result.to
                            ),
                      this.$cache.input.data('from', this.result.from),
                      this.$cache.input.data('to', this.result.to));
            },
            callOnStart() {
                this.writeToInput(),
                    this.options.onStart &&
                        typeof this.options.onStart === 'function' &&
                        (this.options.scope
                            ? this.options.onStart.call(
                                  this.options.scope,
                                  this.result
                              )
                            : this.options.onStart(this.result));
            },
            callOnChange() {
                this.writeToInput(),
                    this.options.onChange &&
                        typeof this.options.onChange === 'function' &&
                        (this.options.scope
                            ? this.options.onChange.call(
                                  this.options.scope,
                                  this.result
                              )
                            : this.options.onChange(this.result));
            },
            callOnFinish() {
                this.writeToInput(),
                    this.options.onFinish &&
                        typeof this.options.onFinish === 'function' &&
                        (this.options.scope
                            ? this.options.onFinish.call(
                                  this.options.scope,
                                  this.result
                              )
                            : this.options.onFinish(this.result));
            },
            callOnUpdate() {
                this.writeToInput(),
                    this.options.onUpdate &&
                        typeof this.options.onUpdate === 'function' &&
                        (this.options.scope
                            ? this.options.onUpdate.call(
                                  this.options.scope,
                                  this.result
                              )
                            : this.options.onUpdate(this.result));
            },
            toggleInput() {
                this.$cache.input.toggleClass('irs-hidden-input'),
                    this.has_tab_index
                        ? this.$cache.input.prop('tabindex', -1)
                        : this.$cache.input.removeProp('tabindex'),
                    (this.has_tab_index = !this.has_tab_index);
            },
            convertToPercent(t, i) {
                let s;
                const o = this.options.max - this.options.min;
                const e = o / 100;
                return o
                    ? ((s = (i ? t : t - this.options.min) / e),
                      this.toFixed(s))
                    : ((this.no_diapason = !0), 0);
            },
            convertToValue(t) {
                let i;
                let s;
                let o = this.options.min;
                let e = this.options.max;
                const h = o.toString().split('.')[1];
                const r = e.toString().split('.')[1];
                let n = 0;
                let a = 0;
                if (t === 0) {
                    return this.options.min;
                }
                if (t === 100) {
                    return this.options.max;
                }
                h && (n = i = h.length),
                    r && (n = s = r.length),
                    i && s && (n = s <= i ? i : s),
                    o < 0 &&
                        ((o = Number((o + (a = Math.abs(o))).toFixed(n))),
                        (e = Number((e + a).toFixed(n))));
                let c;
                let l = ((e - o) / 100) * t + o;
                const _ = this.options.step.toString().split('.')[1];
                return (
                    (l = _
                        ? Number(l.toFixed(_.length))
                        : ((l /= this.options.step),
                          Number((l *= this.options.step).toFixed(0)))),
                    a && (l -= a),
                    (c = _ ? Number(l.toFixed(_.length)) : this.toFixed(l)) <
                    this.options.min
                        ? (c = this.options.min)
                        : c > this.options.max && (c = this.options.max),
                    c
                );
            },
            calcWithStep(t) {
                let i = Math.round(t / this.coords.p_step) * this.coords.p_step;
                return (
                    i > 100 && (i = 100),
                    t === 100 && (i = 100),
                    this.toFixed(i)
                );
            },
            checkMinInterval(t, i, s) {
                let o;
                let e;
                const h = this.options;
                return h.min_interval
                    ? ((o = this.convertToValue(t)),
                      (e = this.convertToValue(i)),
                      s === 'from'
                          ? e - o < h.min_interval && (o = e - h.min_interval)
                          : o - e < h.min_interval && (o = e + h.min_interval),
                      this.convertToPercent(o))
                    : t;
            },
            checkMaxInterval(t, i, s) {
                let o;
                let e;
                const h = this.options;
                return h.max_interval
                    ? ((o = this.convertToValue(t)),
                      (e = this.convertToValue(i)),
                      s === 'from'
                          ? e - o > h.max_interval && (o = e - h.max_interval)
                          : o - e > h.max_interval && (o = e + h.max_interval),
                      this.convertToPercent(o))
                    : t;
            },
            checkDiapason(t, i, s) {
                let o = this.convertToValue(t);
                const e = this.options;
                return (
                    typeof i !== 'number' && (i = e.min),
                    typeof s !== 'number' && (s = e.max),
                    o < i && (o = i),
                    s < o && (o = s),
                    this.convertToPercent(o)
                );
            },
            toFixed(t) {
                return Number((t = t.toFixed(20)));
            },
            _prettify(t) {
                return this.options.prettify_enabled
                    ? this.options.prettify &&
                      typeof this.options.prettify === 'function'
                        ? this.options.prettify(t)
                        : this.prettify(t)
                    : t;
            },
            prettify(t) {
                return t
                    .toString()
                    .replace(
                        /(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g,
                        `$1${this.options.prettify_separator}`
                    );
            },
            checkEdges(t, i) {
                return (
                    this.options.force_edges &&
                        (t < 0 ? (t = 0) : 100 - i < t && (t = 100 - i)),
                    this.toFixed(t)
                );
            },
            validate() {
                let t;
                let i;
                const s = this.options;
                const o = this.result;
                const e = s.values;
                const h = e.length;
                if (
                    (typeof s.min === 'string' && (s.min = Number(s.min)),
                    typeof s.max === 'string' && (s.max = Number(s.max)),
                    typeof s.from === 'string' && (s.from = Number(s.from)),
                    typeof s.to === 'string' && (s.to = Number(s.to)),
                    typeof s.step === 'string' && (s.step = Number(s.step)),
                    typeof s.from_min === 'string' &&
                        (s.from_min = Number(s.from_min)),
                    typeof s.from_max === 'string' &&
                        (s.from_max = Number(s.from_max)),
                    typeof s.to_min === 'string' &&
                        (s.to_min = Number(s.to_min)),
                    typeof s.to_max === 'string' &&
                        (s.to_max = Number(s.to_max)),
                    typeof s.grid_num === 'string' &&
                        (s.grid_num = Number(s.grid_num)),
                    s.max < s.min && (s.max = s.min),
                    h)
                ) {
                    for (
                        s.p_values = [],
                            s.min = 0,
                            s.max = h - 1,
                            s.step = 1,
                            s.grid_num = s.max,
                            s.grid_snap = !0,
                            i = 0;
                        i < h;
                        i++
                    ) {
                        (t = Number(e[i])),
                            (t = isNaN(t)
                                ? e[i]
                                : ((e[i] = t), this._prettify(t))),
                            s.p_values.push(t);
                    }
                }
                (typeof s.from !== 'number' || isNaN(s.from)) &&
                    (s.from = s.min),
                    (typeof s.to !== 'number' || isNaN(s.to)) && (s.to = s.max),
                    s.type === 'single'
                        ? (s.from < s.min && (s.from = s.min),
                          s.from > s.max && (s.from = s.max))
                        : (s.from < s.min && (s.from = s.min),
                          s.from > s.max && (s.from = s.max),
                          s.to < s.min && (s.to = s.min),
                          s.to > s.max && (s.to = s.max),
                          this.update_check.from &&
                              (this.update_check.from !== s.from &&
                                  s.from > s.to &&
                                  (s.from = s.to),
                              this.update_check.to !== s.to &&
                                  s.to < s.from &&
                                  (s.to = s.from)),
                          s.from > s.to && (s.from = s.to),
                          s.to < s.from && (s.to = s.from)),
                    (typeof s.step !== 'number' ||
                        isNaN(s.step) ||
                        !s.step ||
                        s.step < 0) &&
                        (s.step = 1),
                    typeof s.from_min === 'number' &&
                        s.from < s.from_min &&
                        (s.from = s.from_min),
                    typeof s.from_max === 'number' &&
                        s.from > s.from_max &&
                        (s.from = s.from_max),
                    typeof s.to_min === 'number' &&
                        s.to < s.to_min &&
                        (s.to = s.to_min),
                    typeof s.to_max === 'number' &&
                        s.from > s.to_max &&
                        (s.to = s.to_max),
                    o &&
                        (o.min !== s.min && (o.min = s.min),
                        o.max !== s.max && (o.max = s.max),
                        (o.from < o.min || o.from > o.max) && (o.from = s.from),
                        (o.to < o.min || o.to > o.max) && (o.to = s.to)),
                    (typeof s.min_interval !== 'number' ||
                        isNaN(s.min_interval) ||
                        !s.min_interval ||
                        s.min_interval < 0) &&
                        (s.min_interval = 0),
                    (typeof s.max_interval !== 'number' ||
                        isNaN(s.max_interval) ||
                        !s.max_interval ||
                        s.max_interval < 0) &&
                        (s.max_interval = 0),
                    s.min_interval &&
                        s.min_interval > s.max - s.min &&
                        (s.min_interval = s.max - s.min),
                    s.max_interval &&
                        s.max_interval > s.max - s.min &&
                        (s.max_interval = s.max - s.min);
            },
            decorate(t, i) {
                let s = '';
                const o = this.options;
                return (
                    o.prefix && (s += o.prefix),
                    (s += t),
                    o.max_postfix &&
                        (o.values.length && t === o.p_values[o.max]
                            ? ((s += o.max_postfix), o.postfix && (s += ' '))
                            : i === o.max &&
                              ((s += o.max_postfix), o.postfix && (s += ' '))),
                    o.postfix && (s += o.postfix),
                    s
                );
            },
            updateFrom() {
                (this.result.from = this.options.from),
                    (this.result.from_percent = this.convertToPercent(
                        this.result.from
                    )),
                    (this.result.from_pretty = this._prettify(
                        this.result.from
                    )),
                    this.options.values &&
                        (this.result.from_value =
                            this.options.values[this.result.from]);
            },
            updateTo() {
                (this.result.to = this.options.to),
                    (this.result.to_percent = this.convertToPercent(
                        this.result.to
                    )),
                    (this.result.to_pretty = this._prettify(this.result.to)),
                    this.options.values &&
                        (this.result.to_value =
                            this.options.values[this.result.to]);
            },
            updateResult() {
                (this.result.min = this.options.min),
                    (this.result.max = this.options.max),
                    this.updateFrom(),
                    this.updateTo();
            },
            appendGrid() {
                if (this.options.grid) {
                    let t;
                    let i;
                    let s;
                    let o;
                    let e;
                    let h;
                    const r = this.options;
                    const n = r.max - r.min;
                    let a = r.grid_num;
                    let c = 0;
                    let l = 4;
                    let _ = '';
                    for (
                        this.calcGridMargin(),
                            r.grid_snap && (a = n / r.step),
                            a > 50 && (a = 50),
                            s = this.toFixed(100 / a),
                            a > 4 && (l = 3),
                            a > 7 && (l = 2),
                            a > 14 && (l = 1),
                            a > 28 && (l = 0),
                            t = 0;
                        t < a + 1;
                        t++
                    ) {
                        for (
                            o = l,
                                (c = this.toFixed(s * t)) > 100 && (c = 100),
                                e =
                                    ((this.coords.big[t] = c) - s * (t - 1)) /
                                    (o + 1),
                                i = 1;
                            i <= o && c !== 0;
                            i++
                        ) {
                            _ += `<span class="irs-grid-pol small" style="left: ${this.toFixed(
                                c - e * i
                            )}%"></span>`;
                        }
                        (_ += `<span class="irs-grid-pol" style="left: ${c}%"></span>`),
                            (h = this.convertToValue(c)),
                            (_ += `<span class="irs-grid-text js-grid-text-${t}" style="left: ${c}%">${(h =
                                r.values.length
                                    ? r.p_values[h]
                                    : this._prettify(h))}</span>`);
                    }
                    (this.coords.big_num = Math.ceil(a + 1)),
                        this.$cache.cont.addClass('irs-with-grid'),
                        this.$cache.grid.html(_),
                        this.cacheGridLabels();
                }
            },
            cacheGridLabels() {
                let t;
                let i;
                const s = this.coords.big_num;
                for (i = 0; i < s; i++) {
                    (t = this.$cache.grid.find(`.js-grid-text-${i}`)),
                        this.$cache.grid_labels.push(t);
                }
                this.calcGridLabels();
            },
            calcGridLabels() {
                let t;
                let i;
                const s = [];
                const o = [];
                const e = this.coords.big_num;
                for (t = 0; t < e; t++) {
                    (this.coords.big_w[t] = this.$cache.grid_labels[
                        t
                    ].outerWidth(!1)),
                        (this.coords.big_p[t] = this.toFixed(
                            (this.coords.big_w[t] / this.coords.w_rs) * 100
                        )),
                        (this.coords.big_x[t] = this.toFixed(
                            this.coords.big_p[t] / 2
                        )),
                        (s[t] = this.toFixed(
                            this.coords.big[t] - this.coords.big_x[t]
                        )),
                        (o[t] = this.toFixed(s[t] + this.coords.big_p[t]));
                }
                for (
                    this.options.force_edges &&
                        (s[0] < -this.coords.grid_gap &&
                            ((s[0] = -this.coords.grid_gap),
                            (o[0] = this.toFixed(s[0] + this.coords.big_p[0])),
                            (this.coords.big_x[0] = this.coords.grid_gap)),
                        o[e - 1] > 100 + this.coords.grid_gap &&
                            ((o[e - 1] = 100 + this.coords.grid_gap),
                            (s[e - 1] = this.toFixed(
                                o[e - 1] - this.coords.big_p[e - 1]
                            )),
                            (this.coords.big_x[e - 1] = this.toFixed(
                                this.coords.big_p[e - 1] - this.coords.grid_gap
                            )))),
                        this.calcGridCollision(2, s, o),
                        this.calcGridCollision(4, s, o),
                        t = 0;
                    t < e;
                    t++
                ) {
                    (i = this.$cache.grid_labels[t][0]),
                        this.coords.big_x[t] !== Number.POSITIVE_INFINITY &&
                            (i.style.marginLeft = `${-this.coords.big_x[t]}%`);
                }
            },
            calcGridCollision(t, i, s) {
                let o;
                let e;
                let h;
                const r = this.coords.big_num;
                for (o = 0; o < r && !(r <= (e = o + t / 2)); o += t) {
                    (h = this.$cache.grid_labels[e][0]),
                        s[o] <= i[e]
                            ? (h.style.visibility = 'visible')
                            : (h.style.visibility = 'hidden');
                }
            },
            calcGridMargin() {
                this.options.grid_margin &&
                    ((this.coords.w_rs = this.$cache.rs.outerWidth(!1)),
                    this.coords.w_rs &&
                        (this.options.type === 'single'
                            ? (this.coords.w_handle =
                                  this.$cache.s_single.outerWidth(!1))
                            : (this.coords.w_handle =
                                  this.$cache.s_from.outerWidth(!1)),
                        (this.coords.p_handle = this.toFixed(
                            (this.coords.w_handle / this.coords.w_rs) * 100
                        )),
                        (this.coords.grid_gap = this.toFixed(
                            this.coords.p_handle / 2 - 0.1
                        )),
                        (this.$cache.grid[0].style.width = `${this.toFixed(
                            100 - this.coords.p_handle
                        )}%`),
                        (this.$cache.grid[0].style.left = `${this.coords.grid_gap}%`)));
            },
            update(t) {
                this.input &&
                    ((this.is_update = !0),
                    (this.options.from = this.result.from),
                    (this.options.to = this.result.to),
                    (this.update_check.from = this.result.from),
                    (this.update_check.to = this.result.to),
                    (this.options = a.extend(this.options, t)),
                    this.validate(),
                    this.updateResult(t),
                    this.toggleInput(),
                    this.remove(),
                    this.init(!0));
            },
            reset() {
                this.input && (this.updateResult(), this.update());
            },
            destroy() {
                this.input &&
                    (this.toggleInput(),
                    this.$cache.input.prop('readonly', !1),
                    a.data(this.input, 'ionRangeSlider', null),
                    this.remove(),
                    (this.input = null),
                    (this.options = null));
            },
        }),
            (a.fn.ionRangeSlider = function (t) {
                return this.each(function () {
                    a.data(this, 'ionRangeSlider') ||
                        a.data(this, 'ionRangeSlider', new h(this, t, o++));
                });
            }),
            (function () {
                for (
                    var h = 0, t = ['ms', 'moz', 'webkit', 'o'], i = 0;
                    i < t.length && !l.requestAnimationFrame;
                    ++i
                ) {
                    (l.requestAnimationFrame =
                        l[`${t[i]}RequestAnimationFrame`]),
                        (l.cancelAnimationFrame =
                            l[`${t[i]}CancelAnimationFrame`] ||
                            l[`${t[i]}CancelRequestAnimationFrame`]);
                }
                l.requestAnimationFrame ||
                    (l.requestAnimationFrame = function (t, i) {
                        const s = new Date().getTime();
                        const o = Math.max(0, 16 - (s - h));
                        const e = l.setTimeout(() => {
                            t(s + o);
                        }, o);
                        return (h = s + o), e;
                    }),
                    l.cancelAnimationFrame ||
                        (l.cancelAnimationFrame = function (t) {
                            clearTimeout(t);
                        });
            })();
    });

    // Init price Slider
    $('.js-range-slider').ionRangeSlider({
        type: 'double',
        skin: 'round',
        min: 0,
        max: 500,
        from: 0,
        to: 500,
        grid: false,
        onChange(data) {
            const $priceMin = $('.price-range .price-min');
            const $priceMax = $('.price-range .price-max');

            $priceMin.val(data.from);
            $priceMax.val(data.to);
        },
        onFinish() {
            $priceInputs.trigger('change');
        },
    });

    const priceSlider = $('.js-range-slider').data('ionRangeSlider');
    var $priceInputs = $('.price-range-input');

    // Update State of Price Slider when inputs was changed
    $priceInputs.on('input', function () {
        const priceMax = parseFloat($('.price-range .price-max').attr('max'));

        if (parseFloat($(this).val()) > priceMax) {
            $(this).val(priceMax);
        }

        const priceMaxValue = $('.price-range .price-max').val();
        const priceMinValue = $('.price-range .price-min').val();

        priceSlider.update({
            from: priceMinValue,
            to: priceMaxValue,
        });
    });

    // Other Filters
    const $filterPlaceholder = $('.filter-new__placeholder');
    const $filtersDropdown = $('.filter-new__items');
    const filterParent = '.filter-new__block';
    const removeFilter = '.remove-option';
    const removeAllFilter = '.reset-all-filters';
    const closeIcon =
        '<svg class="remove-option" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="33" height="33" viewBox="0 0 33 33"><defs><path id="mg51a" d="M2707.627 76.685l30.668 30.668-.94.939-30.668-30.668z"/><path id="mg51b" d="M2706.687 107.374l30.668-30.668.94.94-30.669 30.667z"/></defs><g><g transform="translate(-2706 -76)"><g><use xlink:href="#mg51a"/></g><g><use xlink:href="#mg51b"/></g></g></g></svg>';
    const $arrowIcon = $(`${filterParent} svg`);

    // Show DropDown by click on select
    $filterPlaceholder.on('click', function (e) {
        e.preventDefault();

        const $thisFilterDropdown = $(this).parent().find('.filter-new__items');

        if (!$thisFilterDropdown.is(':visible')) {
            $filtersDropdown.hide();
            $arrowIcon.removeClass('rotate');
            $(filterParent).removeClass('open');
        }

        $thisFilterDropdown.toggle();
        $(this)
            .parents(filterParent)
            .toggleClass('open')
            .find('svg')
            .toggleClass('rotate');
    });

    // Create object for feature filtering
    const filterObj = {
        color: [],
        size: [],
        type: [],
        price: [],
        fabric: [],
        style: [],
        occasion: [],
    };

    // Click on filter checkbox
    $('.filter-new__item [type="checkbox"]').on('change', function () {
        const optionTitle = $(this).attr('data-option');
        const optionDataValue = $(this).attr('data-value');
        const $selectedRow = $('.selected-filters');
        let optionValue;

        if (optionTitle === 'size') {
            optionValue = $(this).attr('data-value').split('*').join(''); // remove ** from size value for selected sort title
        } else {
            optionValue = $(this).attr('data-value');
        }

        if ($(this).is(':checked')) {
            if ($(`[data-selected-filter="${optionTitle}"]`).length) {
                $(`[data-selected-filter="${optionTitle}"] ul`).append(
                    `<li data-selected-value="${optionDataValue}">${optionValue}${closeIcon}</li>`
                );
            } else {
                $selectedRow.append(
                    `<div class="selected-filter" data-selected-filter="${optionTitle}">` +
                        '              <ul>' +
                        `                <li data-selected-value="${optionDataValue}">${optionValue}${closeIcon}</li>` +
                        '              </ul>' +
                        '            </div>'
                );
                
                $('.reset-all-filters').show();
            }

            filterObj[optionTitle].push(optionDataValue); // push selected variant to object
        } else {
            if (
                $(`[data-selected-filter="${optionTitle}"] ul li`).length === 1
            ) {
                $(`[data-selected-filter="${optionTitle}"]`).remove();

                if (!$('[data-selected-filter]').length) {
                    $('.reset-all-filters').hide();
                }
            } else {
                $(
                    `[data-selected-filter="${optionTitle}"] ul li[data-selected-value="${optionDataValue}"]`
                ).remove();
            }

            filterObj[optionTitle] = filterObj[optionTitle].filter(
                (e) => e !== optionDataValue
            ); // remove unselected variant from object
        }

        filterProduct();
    });

    $('.filter-new__items .price-range-input').on('change', function () {
        const optionTitle = $(this)
            .parents('.input-groups')
            .attr('data-option');
        const priceMin = $(this)
            .parents('.input-groups')
            .find('.price-min')
            .attr('min');
        const priceMax = $(this)
            .parents('.input-groups')
            .find('.price-max')
            .attr('max');
        const priceMinVal = $(this)
            .parents('.input-groups')
            .find('.price-min')
            .val();
        const priceMaxVal = $(this)
            .parents('.input-groups')
            .find('.price-max')
            .val();
        const optionValue = `£${priceMinVal} - ` + `£${priceMaxVal}`;
        const $selectedRow = $('.selected-filters');

        if (priceMin === priceMinVal && priceMax === priceMaxVal) {
            $(`[data-selected-filter="${optionTitle}"]`).remove();

            if (!$('[data-selected-filter]').length) {
                $('.reset-all-filters').hide();
            }

            filterObj.price[0] = priceMin;
            filterObj.price[1] = priceMax;
        } else {
            if ($(`[data-selected-filter="${optionTitle}"]`).length) {
                $(`[data-selected-filter="${optionTitle}"] ul li`)
                    .data('selected-value', optionValue)
                    .html(optionValue + closeIcon);
            } else {
                $selectedRow.append(
                    `<div class="selected-filter" data-selected-filter="${optionTitle}">` +
                        `              <span class="selected-filter__title">${optionTitle}:</span>` +
                        '              <ul>' +
                        `                <li class="price-choose" data-selected-value="${optionValue}">${optionValue}${closeIcon}</li>` +
                        '              </ul>' +
                        '            </div>'
                );
            }

            filterObj.price[0] = priceMinVal;
            filterObj.price[1] = priceMaxVal;
        }

        filterProduct();
    });

    function filterProduct() {
        const newProduct = '.new-grid__item';
        const $newGrid = $('.new-grid');
        const nofoundMessage =
            '<p class="no-found-message">0 products found with these filter options.</p>';
        let firstFilter = true;

        if ($('.no-found-message').length) {
            $('.no-found-message').remove();
        }
        $(newProduct).show();

        $.each(filterObj, (key, value) => {
            if (value.length && firstFilter) {
                firstFilter = false;

                $(newProduct).hide();

                if (key === 'price') {
                    $(newProduct)
                        .filter(function () {
                            const newProductPrice = parseFloat(
                                $(this).data(key)
                            );

                            return (
                                parseFloat(value[0]) <= newProductPrice &&
                                newProductPrice <= parseFloat(value[1])
                            );
                        })
                        .show();
                } else {
                    $.each(value, (i) => {
                        $(newProduct)
                            .filter(function () {
                                return (
                                    $(this).data(key).indexOf(value[i]) !== -1
                                );
                            })
                            .show();
                    });
                }
            } else if (value.length) {
                if (key === 'price') {
                    $(`${newProduct}:visible`)
                        .filter(function () {
                            const newProductPrice = parseFloat(
                                $(this).data(key)
                            );

                            return (
                                parseFloat(value[0]) <= newProductPrice &&
                                newProductPrice <= parseFloat(value[1])
                            );
                        })
                        .addClass('filtered');
                } else {
                    $.each(value, (i) => {
                        $(`${newProduct}:visible`)
                            .filter(function () {
                                return (
                                    $(this).data(key).indexOf(value[i]) !== -1
                                );
                            })
                            .addClass('filtered');
                    });
                }

                $(newProduct).not('.filtered').hide();
                $(`${newProduct}.filtered`).removeClass('filtered');
            }
        });

        if (
            !$(`${newProduct}:visible`).length &&
            !$('.no-found-message').length
        ) {
            $newGrid.after(nofoundMessage);
        }
    }

    $(document).on('click', removeFilter, function () {
        if ($(this).parent().hasClass('price-choose')) {
            const priceMinValue = $('.price-range .price-min').attr('min');
            const priceMaxValue = $('.price-range .price-min').attr('max');
            const $priceMin = $('.price-range .price-min');
            const $priceMax = $('.price-range .price-max');

            priceSlider.reset();
            $priceMin.val(priceMinValue);
            $priceMax.val(priceMaxValue);
            $priceInputs.trigger('change');
        } else {
            const removeValue = $(this).parent().attr('data-selected-value');

            $(`[data-value="${removeValue}"]`).click();
        }
    });

    $(document).on('click', removeAllFilter, (e) => {
        e.preventDefault();

        const priceMinValue = $('.price-range .price-min').attr('min');
        const priceMaxValue = $('.price-range .price-min').attr('max');
        const $priceMin = $('.price-range .price-min');
        const $priceMax = $('.price-range .price-max');

        priceSlider.reset();
        $priceMin.val(priceMinValue);
        $priceMax.val(priceMaxValue);
        $priceInputs.trigger('change');

        $('.filter-new__item input:checkbox')
            .removeAttr('checked')
            .trigger('change');
    });

    $(document).on('click', '.sort-item', function () {
        const thisValue = $(this).attr('data-value');

        $('.filters-toolbar__input-wrapper #SortBy')
            .val(thisValue)
            .trigger('change');
    });

    $(document).on('click', (e) => {
        const $target = $(e.target);

        if (
            !$target.closest('.filter-new__items, .filter-new__block').length &&
            $('.filter-new__items').is(':visible')
        ) {
            $filtersDropdown.hide();
            $arrowIcon.removeClass('rotate');
            $(filterParent).removeClass('open');
        }
    });

    // PLP add to cart
    function swatchSelector() {
        $('.plp-swatch-element :radio').on('change', function () {
            const switchVariantId = $(this).attr('data-variant-id');
            $(this)
                .parents('form')
                .find('.product-form__variants')
                .val(switchVariantId);
        });
    }
    swatchSelector();

    // Sticky Filter header
    if ($('.collection-filters-menu').length) {
        const $filtersMenu = $('.collection-filters-menu');
        const $plpHeader = $('.collection-header');
        const offsetFilter = $('.collection-filters').offset().top;
        const heightFilter = $('.collection-filters-menu').outerHeight();

        // Hide Header on on scroll down
        let didScroll;
        let lastScrollTop = 0;
        const delta = 5;

        $(window).scroll((event) => {
            if ($(window).width() > 1064) {
                didScroll = true;
            }
        });

        setInterval(() => {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

        function hasScrolled() {
            const st = $(this).scrollTop();

            // Make sure they scroll more than delta
            if (Math.abs(lastScrollTop - st) <= delta) {
                return;
            }

            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.
            if (
                (st > lastScrollTop && st > heightFilter) ||
                $(window).scrollTop() < offsetFilter
            ) {
                // Scroll Down
                $plpHeader.css('margin-bottom', '0');
                $filtersMenu.removeClass('fixed');
            } else {
                // Scroll Up
                if (
                    (st + $(window).height() < $(document).height()) &
                    ($(window).scrollTop() >= offsetFilter + heightFilter)
                ) {
                    $plpHeader.css('margin-bottom', heightFilter + 15);
                    $filtersMenu.addClass('fixed');
                }
            }

            lastScrollTop = st;
        }
    }

    //    if ($(window).width() > 767) {

    // }

    //   $('h2').on('click', function() {

    //          $('.slideshow ').slick('slickRemove',$('.slick-slide').index(this) );

    //   });

    if ($(window).width() < 989) {
        $('.slideshow--large').slick(
            'slickRemove',
            $('.slideshow--large').index(this) - -1
        );
    }

    if ($(window).width() >= 990) {
        $('.toggle-search').click(function () {
            $('.custom-search-form').slideToggle('slow');
            $('.custom-search-form input').focus();
        });

        $('.toggle-search').click(function () {
            if ($('.site-header').hasClass('has-open-search')) {
                $('.site-header').removeClass('has-open-search');
                $(
                    '.site-header__mobile-nav .mobile-header-left .site-header__search'
                ).removeClass('has-open-search');
                $('.site-header__mobile-nav .site-header__search').removeClass(
                    'has-open-search'
                );
            } else {
                $('.site-header').addClass('has-open-search');
                $(
                    '.site-header__mobile-nav .mobile-header-left .site-header__search'
                ).addClass('has-open-search');
                $('.site-header__mobile-nav .site-header__search').addClass(
                    'has-open-search'
                );
            }
        });
    }

    if ($(window).width() < 990) {
        $('.toggle-search').on('click', function () {
            $('.custom-search-form').slideToggle('fast');
            $('.custom-search-form input').focus();
        });
      $('.toggle-search').click(function () {
            if ($('.site-header').hasClass('has-open-search')) {
                $('.site-header').removeClass('has-open-search');
                $(
                    '.site-header__mobile-nav .mobile-header-left .site-header__search'
                ).removeClass('has-open-search');
                $('.site-header__mobile-nav .site-header__search').removeClass(
                    'has-open-search'
                );
            } else {
                $('.site-header').addClass('has-open-search');
                $(
                    '.site-header__mobile-nav .mobile-header-left .site-header__search'
                ).addClass('has-open-search');
                $('.site-header__mobile-nav .site-header__search').addClass(
                    'has-open-search'
                );
            }
        });
    }

    // window.addEventListener('mouseup', function(e) {
    //   var sh = $('.toggle-search');
    //   if (e.target != sh && e.target.parentNode != sh) {
    //     $('.site-header').removeClass('has-open-search');
    //     $('.site-header__mobile-nav .mobile-header-left .site-header__search').removeClass('has-open-search');
    //     $('.site-header__mobile-nav .site-header__search').removeClass('has-open-search');
    //     $('.custom-search-form').css("display", "none");
    //   }
    // });

    // Switch Submenu Image
    var subMenus = document.querySelectorAll('.site-nav__dropdown-inner');

    subMenus.forEach((subMenu) => {
        let previewImage = subMenu.querySelector('.category_image');
        let menuItems = subMenu.querySelectorAll('[data-image]');

        menuItems.forEach((item) => {
            item.onmouseover = () => {
                if (item.dataset.image) {
                    previewImage.src = item.dataset.image;
                }
            };
        });
    });

    /* ----------------------------------------------------------------------
    | Headroom
    |------------------------------------------------------------------------
    | Detect when Header has scrolled
    */

    var options = {
        offset: 90,
        classes: {
            // when element is initialised
            initial: 'has--headroom',
            // when scrolling up
            pinned: 'is--pinned',
            // when scrolling down
            unpinned: 'is--unpinned',
            // when above offset
            top: 'is--top',
            // when below offset
            notTop: 'is--not-top',
            // when at bottom of scoll area
            bottom: 'is--bottom',
            // when not at bottom of scroll area
            notBottom: 'is--not-bottom',
            // when frozen method has been called
            frozen: 'is--frozen',
        },
    };

    var $siteHeader = $('.site-header');

   // $siteHeader.headroom(options);

    $siteHeader.on('mouseenter', function () {
        $(this).addClass('has-hover');
    });

    $siteHeader.on('mouseleave', function () {
        $(this).removeClass('has-hover');
    });


    // Prevent IOS long press on links
    $('a').on('touchstart', function () {
        $(this).trigger('click');
    });

});

// When the user scrolls the page, execute myFunction
window.onscroll = function() {myFunction()};

// Get the header
var header = document.getElementById("site-header");

// Get the offset position of the navbar
var sticky = header.offsetTop;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("is--not-top");
  } else {
    header.classList.remove("is--not-top");
  }
}


$('#site-header').hover(
       function(){ $(this).addClass('has-hover') },
       function(){ $(this).removeClass('has-hover') }
)

$('#quickbuy_overlay').click( function() {
		$("#quickbuy_overlay").removeClass("quickbuy_overlay-show");
		$("body").removeClass("quickbuy_overlay-show");
    $("form").removeClass("quick-buy-visible");
} );


/* ----------------------------------------------------------------------
| Sustainability Template
|------------------------------------------------------------------------
| Fade Up Section when in viewport
*/

function reveal() {
  var reveals = document.querySelectorAll(".template-page-sustainability .index-section");

  for (var i = 0; i < reveals.length; i++) {
    var windowHeight = window.innerHeight;
    var elementTop = reveals[i].getBoundingClientRect().top;
    var elementVisible = 150;

    if (elementTop < windowHeight - elementVisible) {
      reveals[i].classList.add("in-view");
    } else {
      reveals[i].classList.remove("in-view");
    }
  }
}

window.addEventListener("scroll", reveal);

// Select the iframe by ID
var iframe = document.getElementsByClassName('KHqjJyKjVNT1lCGf2bnQ');

// Get the document inside the iframe
var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

// Find the div element inside the iframe
var div = iframeDoc.getElementsByClassName('.frame-root')[0];

// Change the CSS of the div
div.css('height', '45');